function getCarveOutCalendarDesign() {
    "use strict";
    var lCanEdit = AgentHelper.getPermissionValueById(16) >1;
    var edit = [
        '<div id="uCarveOutDesign" style="float:left; width:23%">',
            '       <div id="uCarveOutHeader" style="text-align:center;display:block"><h3>Create Enrollee Schedule</h3></div><br />',
                    '<div class="uCarveOutDesignControls">',
                        '<div id="uCarveOutScheduleType"><label><span class="cLocalize cEnrolleeScheduleType">Schedule Type</span></label><br><select id="uCarveOutScheduleTypeSelect"></select></div>',
                    ' </div>',
                    '<label><input type="checkbox" id="timeouton" onclick="toggleTimeInTimeOutMode(this)"/><strong> Enable Time Out Mode</strong></label>',
                    '<div class="uCarveOutDesignControls" id="timeinmode">',
                        ' <hr class="style-two"><div id="uCarveOutHeader" style="text-align:center;display:block; float:left;"><h3>New Zone Target</h3></div><br> <br>',
                        ' <div id="uCarveOutScheduleNewTarget"><select id="uCarveOutScheduleNewTargetSelect" onchange="uCarveOutScheduleTarget_OnChange()"></select></div>',
                        ' <div id="uCarveOutScheduleSelection">',
                            '<input placeholder="filter target" type="text"><br>',
                            '<div style="float: right;border-radius:0px;margin-top: 2px;margin-right: 12px; font-size:16px" id="uPopScheduleTarget" class="IconButton Disabled" onclick="popToScheduleTarget(this)" title="Pop to zone favorites.">+/-</div>',
                            '<select style="width:85%" id="uCarveOutScheduleSelectionSelect" onchange="uCarveOutScheduleSelection_OnChange()"></select></div><hr class="style-two">',
                            '<h3>Schedule Targets </h3><br>',
                            '<div><h4><strong>Device Targets</strong> </h4>',
                            '<select style="width:85%" id="uCarveOutDeviceScheduleSelectionSelect" onchange="uCarveOutDeviceScheduleSelection_OnChange()"></select></div><br>',
                            '<h4><strong>Zone Favorites</strong> </h4>',
                            '<div id="uCarveOutScheduleTargetListViewHolder" class="RemovePaddingCarveOut" style="min-height:150px; border: #e6eff7;border-style: solid;border-width: 2px; !important;max-height:200px; width:95%"> Add from Zone Targets</div>',
                            '<p id="TravelScheduleLabel"><label><input type="checkbox" id="uCarveOutScheduleZoneTravel" onclick="toggleTimeInTimeOutMode(this)"/><strong> Travel Schedule</strong></label><p>',
                            '<div id="uCarveOutScheduleZoneCategory"><label><span class="cLocalize cEnrolleeZoneScheduleType">Zone Category</span></label><br><select id="uCarveOutScheduleZoneCategorySelect" onchange="uCarveOutScheduleZoneCategorySelect_OnSelectChange()" class="Validate ValidateRequired ValidateNotNull"></select>',
                            '     <div class="FortyPercentButton Button SaveButton Clickable LargeIconButton Disabled pEnrolleesOffenderSchedules pEnrolleesOffenderSchedulesWrite" id="uSave247Schedule" onclick="saveAllDayFromAbsence(this)"  style="float:right;"><span class="cLocalize cEnrolleeSave">Save 24x7</span></div></div>',
                            '<hr class="style-two">',
                        '  </div>',
                        '  <div id="uCarveOutDesignActions" style="margin-bottom: 30px;">',
                        '     <div class="FortyPercentButton Button SaveButton Disabled Clickable LargeIconButton pEnrolleesOffenderSchedules pEnrolleesOffenderSchedulesWrite" id="uSaveCarveOutButton" onclick="saveCarveOutScheduleCreated(this)"  style="float:left;"><span class="cLocalize cEnrolleeSave">Save</span></div>',
                        '     <div class="FortyPercentButton Button RemoveButton Disabled Clickable LargeIconButton pEnrolleesOffenderSchedules pEnrolleesOffenderSchedulesWrite" id="uRemoveCarveOutButton" onclick="deleteCarveOutScheduleBlocks(this)"  style="float:right;"><span class="cLocalize cEnrolleeRemove">Delete</span></div>',
                        '     <div class="Button RemoveButton Disabled Clickable LargeIconButton pEnrolleesOffenderSchedules pEnrolleesOffenderSchedulesWrite" id="uWipeAllButton" onclick="wipeAllOffenderSchedule(this)" style="display: block;width: 89%;margin-top: 30px;"><span>Wipe All</span></div>',
                        '</div>',
                    '</div>',
    ].join('');
    return [
        '<div id="uCarveOutSchedulePopupHolder">',
            '<div id="uCarveOutScheduleContentPanel" class="NotScrollable" style="border:1px black">',
                    lCanEdit?edit:'',
                    '<div id="uCarveOutScheduleDesignViewHolder" style="float:right; width:',lCanEdit?'75%;':'100%;',' height:100%;"></div>',
                '</div>',
            '</div>'
        ].join('');
}

function SaveOnTimeoutTimeinToggleChange() {
    var lHtml = [];
    var lButtonBar = GenerateButtonCommandBar();

    lHtml.push('<div style="height:80%;">Please save your schedule before proceeding...</div>');
    lHtml.push('</div>');

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', function () {
        saveCarveOutScheduleCreated()
        ClosePopup()
    }).appendTo(lButtonBar);

    DisplayPopup('Save Schedules', lHtml.join(''), lButtonBar, null, true);
}

function toggleTimeInTimeOutMode() {
    "use strict";
    var lTimeOutWindow = $('#timeouton').is(":checked"), lZoneCategory = $("#uCarveOutScheduleZoneCategorySelect");
    var lEditable = 'TimeIn';
    if (lTimeOutWindow) {
        $('#timeinmode').addClass('DisabledDiv')
        lEditable = 'TimeOut'
        lZoneCategory.removeClass();
        if(!isNullOrUndefined(mEnrolleesControls.ScheduleValidator)){
            mEnrolleesControls.ScheduleValidator.scan();
        }
    } else {
        $('#timeinmode').removeClass('DisabledDiv')
        lZoneCategory.addClass("Validate ValidateNotNull");
        if(!isNullOrUndefined(mEnrolleesControls.ScheduleValidator)){
            mEnrolleesControls.ScheduleValidator.scan();
        }
    }

    if (!$('#uSaveCarveOutButton').hasClass('Disabled')) {
        SaveOnTimeoutTimeinToggleChange()
    }


    if (!mEnrolleesControls.carveOutSchedule) return;
    mEnrolleesControls.carveOutSchedule.getRawDataSource().forEach(function (schedule) {
        if (schedule.Type !== lEditable) {
            schedule.editable = false;
            schedule.durationEditable = false
        } else {
            if (lEditable === 'TimeOut' && schedule.data.Id > 0) {
                schedule.editable = false;
                schedule.durationEditable = false;
            } else {
                schedule.editable = true;
                schedule.durationEditable = true;
            }
        }
    })
}
function LockDownSelectAllOnClick() {
    "use strict";

    mEnrolleesControls.LockDownListView.selectAllList();
}

function LockDownRemoveOnClick(self) {
    "use strict";
    var lSelected = mEnrolleesControls.LockDownListView.selectedDataItem();
    var lBuilder = new SumoPredicateBuilder();
    var lData = [];

    if ($(self).hasClass('Disabled')) {
        if (lSelected && lSelected.length > 0)
            mActivityNotification.addNotification('Need to delete recurring absences and future override absences for this target......');
        return false;
    }


    lData = getEnrolleeSchedules().filter(function (schedule) {
        return (!schedule.IsAbsenceSched && schedule.IsRecurring);
    })

    var lSchedules = [];

    // fetch other schedules for 24x7

    lSelected.forEach(function (selected) {
        lSchedules = lSchedules.concat(
            lData.filter(function (sched) {
                sched.IsActive = false;
                return (sched.EntityId == selected.EntityId && sched.ScheduleType == selected.TargetTypeId)
            })
        );
    });

    mActivityNotification.addNotification("Deleting 24x7 Schedules....");
    WriteMultiple(lSchedules, LockDownDelete_OnSuccess, failure, null, true);

    function LockDownDelete_OnSuccess(aParams, aData) {
        mActivityNotification.addNotification("Successfully Deleted 24x7 Schedules!!!");

        aData.forEach(function (schedule) {
            updateOffenderScheduleCache(schedule);
        });

        var lLockDownSchedules = LockDownExists();

        $('.LockDownRemoveButton').addClass('Disabled');

        mEnrolleesControls.LockDownListView.setDataSource(lLockDownSchedules);
        mEnrolleesData.LockDownSchedulesSorted = lLockDownSchedules;
    }
}

function LockDownList_OnSelectChange() {
    "use strict";
    var lSelected = mEnrolleesControls.LockDownListView.selectedDataItem();
    var lAbsences = getCarveOutSchedules(mEnrolleesData.OffenderCurrentId);
    var showDelete = lSelected.length > 0;


    lSelected.forEach(function (schedule) {
        var found = lAbsences.filter(function (absence) {
            var target = getScheduleType(schedule.TargetTypeId);
            return (target == absence.ScheduleType && schedule.EntityId == absence.EntityId && absence.IsRecurring);
        });

        if (showDelete) {
            showDelete = found.length == 0;
        }
    });

    if (showDelete) {
        $('.LockDownRemoveButton').removeClass('Disabled');
    } else {
        $('.LockDownRemoveButton').addClass('Disabled');
    }
}

function lockDownSchedulesGenerator() {
    "use strict";
    var lLockDownSchedules = getCarveOutSchedules(mEnrolleesData.OffenderCurrentId, false);
    var lBuilder = new SumoPredicateBuilder();
    var lAllDayEntities = [];
    var lCleanedSchedules = [];

    lBuilder.AddNewExpressionConditional('IsRecurring', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

    lLockDownSchedules = query(lLockDownSchedules, lBuilder.RootExpression);

    lLockDownSchedules.forEach(function (schedule) {
        var lDiff = checkTimeDiff(schedule.StartTime, schedule.EndTime);
        if (lDiff >= 1439 || lDiff == 1) {
            var lEntity = lAllDayEntities.filter(function (allday) {
                return allday.data.EntityId == schedule.EntityId
            })[0];

            if (lEntity) {
                lEntity.day++;
            } else {
                lAllDayEntities.push({
                    day: 1,
                    data: schedule
                });
            }
        }
    });

    var lAllDay = lAllDayEntities.filter(function (schedule) {
        return schedule.day == 7;
    }).map(function (schedule) { return schedule.data });

    return enrolleesScheduleDataListConverter(lAllDay);
}

function absenceCarveOutLockDownList(aThis) {
    "use strict";
    var lHtml = [];
    var lButtonBar = GenerateButtonCommandBar();

    lHtml.push('<div id="lockdownsection" style="height:200px">');
    lHtml.push('<div id="uEnrolleesLockDownListViewPaginatorHolder"></div>');
    lHtml.push('<div id="uEnrolleesLockDownListViewHolder" style="height:80%;"></div>');
    lHtml.push('</div>');

    GenerateButton(localizeWrapper('cSelectAll'), 'SelectAll', 'LockDownSelectAllOnClick(this)', false).appendTo(lButtonBar);
    GenerateButton(localizeWrapper('cEnrolleeDelete'), 'Remove LockDownRemove', 'LockDownRemoveOnClick(this)', false).appendTo(lButtonBar);

    DisplayPopup('Time In 24x7 Schedules', lHtml.join(''), lButtonBar, null, true);

    $('.LockDownRemoveButton').addClass('Disabled');

    mEnrolleesControls.LockDownListView = new sumo.controls.ListView('uEnrolleesLockDownListView', 'uEnrolleesLockDownListViewHolder', {
        'keyField': 'Id', 'selectMethod': 'ctrlKey', 'cssClass': 'VeritracksListView', 'canUnselect': true, 'localization': true
    }, [
            { 'id': 'Description', 'title': localizeWrapper('cEnrolleeDescription'), 'dataField': 'Name', 'width': 'autoData', 'minWidth': 200, 'maxWidth': 200, 'sortable': true, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'Target', 'title': localizeWrapper('cEnrolleeScheduleTarget'), 'dataField': 'TargetName', 'width': 'autoData', 'minWidth': 200, 'maxWidth': 200, 'sortable': false, 'cssClass': null, 'dataType': 'string', 'formatMethod': null },
            { 'id': 'TargetType', 'title': localizeWrapper('cEnrolleeScheduleTargetType'), 'dataField': 'TargetTypeName', 'width': 'autoData', 'minWidth': 80, 'maxWidth': 80, 'sortable': true, 'cssClass': null, 'dataType': 'number', 'formatMethod': null },
            { 'id': 'ZoneScheduleType', 'title': localizeWrapper('cEnrolleeZoneScheduleType'), 'dataField': 'ZoneScheduleType', 'width': 'autoData', 'minWidth': 80, 'sortable': false, 'cssClass': null, 'dataType': 'number', 'formatMethod': scheduleZoneTypeFormatter }
    ]);

    mEnrolleesControls.LockDownListView.bind('selectedchanged', LockDownList_OnSelectChange);

    var lLockDownSchedules = lockDownSchedulesGenerator();

    mEnrolleesControls.LockDownListView.setDataSource(lLockDownSchedules);
}

/********************************************/
/********CarveOut Calendar Creation********/
/********************************************/
function uCarveOutScheduleButton_OnClick(aFavoriteZoneId) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId);
    var lTitle = 'Enrollee Schedules - ' + lEnrollee.FullName + ' (' + lEnrollee.PrimaryId + ')';

    mEnrolleesData.SoberTrackBlockDelete = [];
    mEnrolleesControls.carveOutSchedule = null;
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', 'saveCarveOutScheduleCreated()'));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeDelete'), 'Remove', 'deleteCarveOutScheduleBlocks()', true));
    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeClose'), 'Close', 'ClosePopup()'));

    DisplayPopup(lTitle, getCarveOutCalendarDesign(), null, false);
    ReloadEnrolleeSchedules(mEnrolleesData.OffenderCurrentId, function () {
        uCarveOutSchedulePopulate_Init();
        populateAbsenceScheduleTargetList();
        uCarveOutScheduleTarget_OnChange();
        applyUserPermissions([16]);
                
        if(aFavoriteZoneId){
            var lData = mEnrolleesData.CarveOutScheduleTargetListView.getDataSource();
            var lZone = getDataItem(aFavoriteZoneId, 'Zones');
            var lScheduleTarget = generateZoneScheduleTarget(lZone);
            mEnrolleesData.CarveOutTargetsClean.push(lScheduleTarget);
            lData[lScheduleTarget.UniqueId] = lScheduleTarget;
            mEnrolleesData.CarveOutScheduleTargetListView.setDataSource(lData);
            setTimeout(function(){
                mEnrolleesData.CarveOutScheduleTargetListView.selected(lScheduleTarget.UniqueId);
            },100);
        }else {
            if (mEnrolleesData.CarveOutTargetsClean[0])
                mEnrolleesData.CarveOutScheduleTargetListView.selected(mEnrolleesData.CarveOutTargetsClean[0].UniqueId);
        }
    }, null, null);
}



function getCarveOutSchedules(aEnrolleeId, absenceFlag) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
    lEnrolleeScheduleDisplays = [],
    lOldSchedules,
    lEnrolleeSchedules = [],
    lTimeZone = getEnrolleeTimeZone(aEnrolleeId),
    lKey;

    //lBuilder.AddNewExpressionConditional('EnrolleeId', aEnrolleeId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    //lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
 

    lOldSchedules = mEnrolleesData.OffenderSchedules;
    for (lKey in lOldSchedules) {
        if (lOldSchedules.hasOwnProperty(lKey)) {
            var lSchedule = new OffenderScheduleDisplay(lOldSchedules[lKey], true);
            if (displayDSTSchedules()) {
                var split = lSchedule.StartTimeLocal.split(" ");

                lSchedule.StartDateUTC = lSchedule.StartTimeLocal;

                lSchedule.StartTimeLocal = getTimeFormatter(lSchedule.StartTimeLocal);
                lSchedule.EndTimeLocal = getTimeFormatter(lSchedule.EndTimeLocal);

                lSchedule.EndDateUTC = split[0] + " " + lSchedule.EndTimeLocal;
            } else {
                lSchedule.StartTime = convertMomentFromStringTimezone(lSchedule.StartTimeUTC, lTimeZone.TimeZoneName);
                lSchedule.EndTime = convertMomentFromStringTimezone(lSchedule.EndTimeUTC, lTimeZone.TimeZoneName);

                if (lSchedule.IsRecurring) {
                    lSchedule.StartDateUTC = moment(lSchedule.StartTime).format('L');
                    lSchedule.EndDateUTC = moment(lSchedule.EndTime).format('L');
                }
            }
            lEnrolleeScheduleDisplays.push(lSchedule);
        }
    }

    return lEnrolleeScheduleDisplays;
}

function uCarveOutSchedulePopulate_Init() {
    "use strict";
    var carveOutDesign = $('<div id="uCarveOutDesignSchedules" style="width:100%;"><div class="loadingGif FixedCenteredDisplay"></div></div>'),
        carveOutDesignHolder = $('#uCarveOutScheduleDesignViewHolder');
        var lCanEdit = AgentHelper.getPermissionValueById(16) >1;
    var lSchedules = getCarveOutSchedules(mEnrolleesData.OffenderCurrentId);
    var lCarveOutPreference = getCarveOutPreference();
    carveOutDesignHolder.append(carveOutDesign);
    if (lCarveOutPreference) {
        $('#timeouton').prop('checked', true);
        toggleTimeInTimeOutMode();
    }
    carveOutScheduleDesignRules_ControlInit();
    $('.PopupWindow').addClass('CarveOutSize');

    $('#uPopupPanel').addClass('LowZIndex');
    mEnrolleesControls.carveOutSchedule = new VeritracksFullCalendarWrapper('#uCarveOutDesignSchedules',
    {
        "defaultView": "agendaWeek",
        "slotEventOverlap": false,
        "selectOverlap": true,
        "multiDaySelect": true,
        "displayEventEnd": true,
        "editable": lCanEdit,
        "aspectRatio": 1.64,
        "selectable": lCanEdit,
        "pastSelectable": lCanEdit,
        "selectHelper": false,
        "selectMultiDay": false,
        "allDaySlot": true,
        "navLinks": true,
        "lazyFetching": true,
        "rightClickOptions": 'agendaWeek,agendaDay,listWeek',
        "leftClickOptions": 'prev,next, today',
        "nowIndicator": true
    },
    lCanEdit?{
        'selectEventHandler': CarveOutSchedule_SelectHandler,
        'selectAllowHandler': CarveOutSchedule_SelectAllowHandler,
        'clickHandler': carveOutSchedule_ClickHandler,
        'afterRender': carveOutSchedule_AfterRender,
        'eventDrop': carveOutSchedule_ResizeOverEventDrop,
        'eventDragStop': carveOut_drapStopHelper,
        'resized': carveOutSchedule_Resized,
        'renderHandler': CarveOutSchedule_RenderHandler,
        "viewRender": carveOutSchedule_ViewRender,
        "afterAllRender": carveOutSchedule_AfterAllRender
    }:{
        "viewRender": carveOutSchedule_ViewRender,
    });

    mEnrolleesControls.carveOutSchedule.setView('agendaDay');
    mEnrolleesControls.carveOutSchedule.setView('agendaWeek');

    mEnrolleesControls.carveOutSchedule.setDataSource(lSchedules);
    if (lSchedules.length > 0) {
        $('#uWipeAllButton').removeClass('Disabled');
    }

    //$('.fc-scroller.fc-time-grid-container').scrollTop(0)

    $('.loadingGif').hide();
}

function carveOut_drapStopHelper(a,b,c,d) {
    console.log('dropped');
}

function carveOutSchedule_AfterAllRender() {
  window.setTimeout(function() {
    $('.fc-scroller.fc-time-grid-container').scrollTop(0)
  }, 100)
}

function createCalendarEvent(schedule) {
    "use strict";
    var lView = $(mEnrolleesControls.carveOutSchedule.calendarId()).fullCalendar('getView');
    var lStartDate = lView.start;
    var lEndDate = lView.end;

    var lScheduleMoment = moment(schedule.StartDateUTC);
    if (schedule.IsReocurring) {
        var lMoment = moment(lStartDate);
        while (lMoment < lEndDate) {
            var lDay = lMoment.day();
            var lFullCalendarObject = new fullCalendarObject(schedule, DisplaySuperShortMomentDate(lMoment), false, schedule.IsReocurring, false);
            if (schedule.IsSunday && lDay == 0) {
                return lFullCalendarObject;
            } else if (schedule.IsMonday && lDay == 1) {
                return lFullCalendarObject;
            } else if (schedule.IsTuesday && lDay == 2) {
                return lFullCalendarObject;
            } else if (schedule.IsWednesday && lDay == 3) {
                return lFullCalendarObject;
            } else if (schedule.IsThursday && lDay == 4) {
                return lFullCalendarObject;
            } else if (schedule.IsFriday && lDay == 5) {
                return lFullCalendarObject;
            } else if (schedule.IsSaturday && lDay == 6) {
                return lFullCalendarObject;
            }
            lMoment.add(1, 'days');
        }
    }

}

function LockDownExists() {
    var lLockDownSchedules = [];
    if (getCarveOutPreference()) {
        lLockDownSchedules = lockDownSchedulesGenerator();

        if (lLockDownSchedules.length > 0) {
            $('#uLockDownButton').show();
        } else {
            $('#uLockDownButton').hide();
        }
    }

    return lLockDownSchedules;
}

function checkTimeDiff(aStart, aEnd, aFormat) {
    var lStart = moment(aStart);
    var lEnd = moment(aEnd);

    if (!aFormat) {
        aFormat = 'minutes';
    }

    return Math.abs(lStart.diff(lEnd, aFormat));
}

function fixOverrideShifts(aDate, aSchedule) {
    "use strict";
    var lDate = moment(aDate);
    var lDay = 0;

    if (aSchedule.IsSunday)
        lDay = 0;
    if (aSchedule.IsMonday)
        lDay = 1;
    if (aSchedule.IsTuesday)
        lDay = 2;
    if (aSchedule.IsWednesday)
        lDay = 3;
    if (aSchedule.IsThursday)
        lDay = 4;
    if (aSchedule.IsFriday)
        lDay = 5;
    if (aSchedule.IsSaturday)
        lDay = 6;

    if (moment(aDate).day() == 0 && lDay == 6) {
        aDate = moment(aDate).add(-7, 'days');
    }

    if (moment(aDate).day() == 6 && lDay == 0) {
        aDate = moment(aDate).add(7, 'days');
    }

    return moment(aDate).weekday(lDay);
}


function carveOutSchedule_ViewRender(aView) {
    "use strict";
    var lDataSource = [],
    lSchedule,
    lStartDate = moment(aView.start),
    lEndDate = moment(aView.end.hour(24)),
    lIsAllDay = false,
    lIsEditable = true,
    lScheduleMoment,
    lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId),
    lBuilder = new SumoPredicateBuilder();
    var aId = mEnrolleesControls.carveOutSchedule.calendarId();
    var lTimeOutWindow = $('#timeouton').is(":checked");
    var aDataSource = mEnrolleesControls.carveOutSchedule.getDataSource().filter(function (data) {
        return data.IsActive
    });
    var rawDataSource = mEnrolleesControls.carveOutSchedule.getRawDataSource();

    rawDataSource = rawDataSource.filter(function (data) {
        if (!data.data) return;
        return data.data.Id == -1;
    });



    mEnrolleesControls.carveOutSchedule.addExtraData("rawSource", rawDataSource);

    // filter out 24/7 exclusion schedules
    if (aView.name != "listWeek") {
        aDataSource = aDataSource.filter(function (schedule) {
            if (schedule.ZoneScheduleType == -1) return schedule;

            var lZone = GetZone(schedule.EntityId);

            if (!lZone) {
                if (!schedule.ZoneName.includes("Exclusion")) {
                    return schedule;
                }
            }
            if (lZone && lZone.Type !== 2) return schedule;
            // check if 24 hours

            if (displayDSTSchedules()) {
                if (Math.abs(moment(schedule.EndTimeLocal, "hh:mi A").diff(moment(schedule.StartTimeLocal, "hh:mi A"), "minutes")) !== 1439) return schedule
            } else {
                if (Math.abs(moment(schedule.StartTimeUTC).diff(moment(schedule.EndTimeUTC), 'minutes')) !== 1) return schedule
            }
        })
    }

    $(aId).fullCalendar('removeEvents');
    aDataSource.forEach(function (schedule) {
            var lSchedule = null;
            var lScheduleStart = moment(schedule.StartDateUTC);
            var lScheduleEnd = moment(schedule.EndDateUTC);
            if (!schedule.IsRecurring) {
                if (lScheduleStart.isBetween(lStartDate, lEndDate)) {
                    var lSchedStart = moment(DisplaySuperShortMomentDate(lScheduleStart) + ' ' + displayShortTime(schedule.StartTime));
                    var lSchedEnd = moment(DisplaySuperShortMomentDate(lScheduleStart) + ' ' + displayShortTime(schedule.EndTime));

                    if (displayDSTSchedules()) {
                        lSchedStart = moment(DisplaySuperShortMomentDate(lScheduleStart) + ' ' + schedule.StartTimeLocal);
                        lSchedEnd = moment(DisplaySuperShortMomentDate(lScheduleStart) + ' ' + schedule.EndTimeLocal);
                    }

                    lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType, schedule.TravelScheduleFlag);
                    lSchedule.borderColor = 'Orange'
                    lSchedule.start = fixOverrideShifts(lSchedStart, schedule);
                    lSchedule.end = fixOverrideShifts(lSchedEnd, schedule);
                }
            } else {
                var lMoment = moment(lStartDate);

                while (lMoment < lEndDate) {
                    var lDay = lMoment.day();
                    var lDate = lMoment.format("MM/DD/YYYY");
                    
                    var lSchedStart = moment(lDate + ' ' + displayShortTime(schedule.StartTime));
                    var lSchedEnd = moment(lDate + ' ' + displayShortTime(schedule.EndTime));

                    if (displayDSTSchedules()) {
                        lSchedStart = moment(lDate + ' ' + schedule.StartTimeLocal);
                        lSchedEnd = moment(lDate + ' ' + schedule.EndTimeLocal);
                    }

                    if (schedule.IsSunday && lDay == 0) {
                        lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType, schedule.TravelScheduleFlag);
                        break;
                    } else if (schedule.IsMonday && lDay == 1) {
                        lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType, schedule.TravelScheduleFlag);
                        break;
                    } else if (schedule.IsTuesday && lDay == 2) {
                        lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType, schedule.TravelScheduleFlag);
                        break;
                    } else if (schedule.IsWednesday && lDay == 3) {
                        lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType, schedule.TravelScheduleFlag);
                        break;
                    } else if (schedule.IsThursday && lDay == 4) {
                        lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType, schedule.TravelScheduleFlag);
                        break;
                    } else if (schedule.IsFriday && lDay == 5) {
                        lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType, schedule.TravelScheduleFlag);
                        break;
                    } else if (schedule.IsSaturday && lDay == 6) {
                        lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType, schedule.TravelScheduleFlag);
                        break;
                    }
                    lMoment.add(1, 'days');
                }
            }

            if (lSchedule) {
                lSchedule.title = schedule.Name;
                lSchedule.data = schedule;
                lSchedule.Type = [7, 8, 10].indexOf(schedule.ScheduleType) === -1 ? 'TimeIn' : 'TimeOut'
                lSchedule.editable = [7, 8, 10].indexOf(schedule.ScheduleType) === -1 ? true : false;
                lSchedule.durationEditable = [7, 8, 10].indexOf(schedule.ScheduleType) === -1 ? true : false;
                if (lSchedule.ScheduleType == 6) {
                    lSchedule.editable = false;
                    lSchedule.durationEditable = false;
                }
                if (lTimeOutWindow) {
                    lSchedule.editable = false;
                    lSchedule.durationEditable = false;
                }
                lDataSource.push(lSchedule);
            }
        });


    var rawData = mEnrolleesControls.carveOutSchedule.getExtraData("rawSource");

    if (rawData.length > 0) {
        rawData.forEach(function (rd) {
            lDataSource.push(rd);
        });
    }

    //disable schedules.

    lDataSource.forEach(function (data) {
        if(!data.data.IsRecurring) return
        var overrideExist = lDataSource.find(function (exist) {
            if (!exist.data.IsRecurring && exist.data.EntityId == data.data.EntityId) {
                return exist.start.date() == moment(data.start).date(); //exist.start.isBetween(moment(data.start),moment(data.end))
            }
        })
        if (overrideExist) {
            data.className = 'CalendarDisabled';
        }
    })

    $(aId).fullCalendar('addEventSource', lDataSource);
    $(aId).fullCalendar('rerenderEvents');
    $('div.qtip:visible').qtip('hide');
}

function CarveOutSchedule_RenderHandler(aEvent) {
    var lParent = $('#' + aEvent._id + 'desc').parent().closest('div').attr('id');
    var qtipId = ''

    if (lParent) {
        qtipId = lParent.replace('-content', '');

        //remove qtip to not leave stale data
        $('#' + qtipId).qtip('api').destroy(true);
    }

}

function updateEventDaysAfterChange(aEvent, dropped) {
    "use strict";
    var lEventDay;
    var lInitialDay = 0;
    var lStartClone = aEvent.start.clone();
    var lEndTimeClone = aEvent.end.clone();
    var lOriginalEnd = moment(aEvent.data.EndTime).format("hh:mmA");

    aEvent.edited = true;

    if (dropped) {
        lStartClone = lStartClone.add(getOffsetOfSaveDate(lStartClone.toDate()), 'minutes'),
        lEndTimeClone = lEndTimeClone.add(getOffsetOfSaveDate(lEndTimeClone.toDate()), 'minutes');
    }

    lEventDay = aEvent.start.day();

    aEvent.data.StartTime = lStartClone.toDate();
    aEvent.data.EndTime = lEndTimeClone.toDate();


    if (aEvent.data.IsSunday) {
        lInitialDay = 0;
        aEvent.data.IsSunday = false;
    }
    if (aEvent.data.IsMonday) {
        lInitialDay = 1;
        aEvent.data.IsMonday = false;
    }
    if (aEvent.data.IsTuesday) {
        lInitialDay = 2;
        aEvent.data.IsTuesday = false;
    }
    if (aEvent.data.IsWednesday) {
        lInitialDay = 3;
        aEvent.data.IsWednesday = false;
    }
    if (aEvent.data.IsThursday) {
        lInitialDay = 4;
        aEvent.data.IsThursday = false;
    }
    if (aEvent.data.IsFriday) {
        lInitialDay = 5;
        aEvent.data.IsFriday = false;
    }
    if (aEvent.data.IsSaturday) {
        lInitialDay = 6;
        aEvent.data.IsSaturday = false;
    }

    if (lEventDay == 0) {
        aEvent.data.IsSunday = true;
    } else if (lEventDay == 1) {
        aEvent.data.IsMonday = true;
    } else if (lEventDay == 2) {
        aEvent.data.IsTuesday = true;
    } else if (lEventDay == 3) {
        aEvent.data.IsWednesday = true;
    } else if (lEventDay == 4) {
        aEvent.data.IsThursday = true;
    } else if (lEventDay == 5) {
        aEvent.data.IsFriday = true;
    } else if (lEventDay == 6) {
        aEvent.data.IsSaturday = true;
    }

    if (!aEvent.data.TitleUpdatedFlag && dropped) {
        var lParentEntity = aEvent.parentEntity;
        if (aEvent.data.Id !== -1) {
            if (aEvent.parentEntity) {
                lParentEntity = aEvent.parentEntity
            } else {
                if(aEvent.title.indexOf(lOriginalEnd) !== -1) {
                    lParentEntity = aEvent.title.split(lOriginalEnd)[1]
                } else {
                    var title = aEvent.title.split("-")

                    title.shift()
                    lParentEntity = title.join("-")
                }
            }
        }

        var lTitle = CarveOutScheduleTitle(aEvent.start, aEvent.end, aEvent.ScheduleType, aEvent.reocurring, lParentEntity);

        if (aEvent.data.TravelScheduleFlag) {
            lTitle = aEvent.title;
        }
        aEvent.title = lTitle;
    }
    if (aEvent.Status !== 'New')
      aEvent.Status = 'Updated';

    return ({
        Event: aEvent,
        Changed: (lEventDay - lInitialDay)
    });
}

function updateCarveOutDeleteEvent(aCurrentEvent, aUpdatedEvent) {
    "use strict";
    var lCurrentEvent = aCurrentEvent;
    var lCurrentDay = lCurrentEvent.start.day();

    lCurrentEvent.start.weekday(lCurrentDay + aUpdatedEvent.Changed);
    lCurrentEvent.end.weekday(lCurrentDay + aUpdatedEvent.Changed);


    lCurrentEvent.start.hours(aUpdatedEvent.Event.start.hours());
    lCurrentEvent.start.minutes(aUpdatedEvent.Event.start.minutes());

    lCurrentEvent.end.hours(aUpdatedEvent.Event.end.hours());
    lCurrentEvent.end.minutes(aUpdatedEvent.Event.end.minutes());
    saveUpdatedCarveOutSchedule(lCurrentEvent, true, true); //save and update ui
}

function carveOutSchedule_Resized(aEvent, jsEvent, revertFunc) {
    carveOutSchedule_ResizeOverEventDrop(aEvent, null, revertFunc, jsEvent);
}

function checkIfCarveOutSchedulesAllowed() {
    var lEnrolleeId = mEnrolleesData.OffenderCurrentId,
    lDeviceAssignments,
    lHasBluPlus = bluPlusCheck(lEnrolleeId),
    lHasBluHome = false,
    lHasDeviceCluster = false,
    lHasBluTag = false,
    lHasSoberTrack = false,
    lDevice,
    lBuilder = new SumoPredicateBuilder(),
    lZone,
    lHtml = [],
    lItem,
    lKey;
    const GPS_DEVICE_LIST=[103,141,151,161];
    if (lEnrolleeId == -1) {
        lEnrolleeId = mEnrolleesControls.veritracksCalendar.getExtraData("enrolleeId");
    }
    lDeviceAssignments = gCurrentDeviceAssignment[lEnrolleeId];

    lHtml.push('<select id="uSchedulesTargetType" onchange="uSchedulesTargetType_OnSelectChange()">');
    if (lHasBluPlus) {
        //lHtml.push('<option value="3" class="pInventoryDeviceClusters pInventory">BLUbox Group</option>'); //FB 1444
        lHtml.push('<option value="3" class="pInventoryDeviceClusters pInventory">BLUbox</option>');
        //lHtml.push('<option value="6" class="">Address</option>');  //FB 1444
        lHtml.push('<option value="6" class="">BLU+ Address</option>');
    } else if (isNullOrUndefined(lDeviceAssignments) || lDeviceAssignments.length === 0) {
        lHtml.push('<option value="1" class="pZones">' + localizeText('cZone') + '</option>');
        lHtml.push('<option value="My" class="pZones">' + localizeText('cZoneIsMine') + '</option>');
        lHtml.push('<option class="pInventoryDevices pInventory" value="2">BLUhome</option>');
        //lHtml.push('<option value="3" class="pInventoryDeviceClusters pInventory">BLUbox Group</option>'); //FB 1444
        lHtml.push('<option value="3" class="pInventoryDeviceClusters pInventory">BLUbox</option>');
        //lHtml.push('<option value="6" class="">Address</option>');      //FB 1444
        lHtml.push('<option value="6" class="">BLU+ Address</option>');
    } else {
        for (lKey in lDeviceAssignments) {
            if (lDeviceAssignments.hasOwnProperty(lKey)) {
                lItem = lDeviceAssignments[lKey];
                lDevice = getDataItem(lItem.Id, 'Devices');
                if ([104, 109].indexOf(lDevice.ProductId) !== -1) {
                    lHasBluHome = true;
                } else if (GPS_DEVICE_LIST.includes(lDevice.ProductId)) { 
                    lHasBluTag = true;
                } else if (lDevice.ProductId === 121) {
                    lHasSoberTrack = true;
                }
            }
        }
        lBuilder.AddNewExpressionConditional('TypeId', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDeviceAssignments = query(mEnrolleesData.SchedulesTargetsClean, lBuilder.RootExpression);
        lHasDeviceCluster = (!isNullOrUndefined(lDeviceAssignments) && count(lDeviceAssignments) > 0);
        if (lHasBluTag) {
            lHtml.push('<option value="1" class="pZones">' + localizeText('cZone') + '</option>');
            lHtml.push('<option value="My" class="pZones">' + localizeText('cZoneIsMine') + '</option>');
        }
        if (lHasBluHome) {
            lHtml.push('<option class="pInventoryDevices pInventory" value="2">BLUhome</option>');
        }
        if (lHasDeviceCluster) {
            //lHtml.push('<option value="3" class="pInventoryDeviceClusters pInventory">BLUbox Group</option>'); // FB 1444
            lHtml.push('<option value="3" class="pInventoryDeviceClusters pInventory">BLUbox</option>');
        }
    }
    lHtml.push('</select>');
    lHtml = lHtml.join('');
    if (lHtml.indexOf('<option') === -1) {
        if (lHasSoberTrack) {
            if (mEnrolleesData.HasEnrolleeMobileApp) {
                return true; 
            } 
        }
        return false;
    }

    return true;
}

function cleanMoveFullCalendar(aEvent, revertFunc) {
    if (!aEvent.end) {
        if (revertFunc) {
            revertFunc();
        }
        return false;
    }
    var lEventEnd = parseInt(aEvent.end.format("H"));
    var lEventStart = parseInt(aEvent.start.format("H"));
    var lEventEndDay = parseInt(aEvent.end.day());
    var lEventStartDay = parseInt(aEvent.start.day());

    if (lEventEnd == 0) {
        if (aEvent.end.format("H") == "0") {
            aEvent.end.minutes(59);
            aEvent.end.seconds(0);
            aEvent.end.hours(23);
            aEvent.end.day(lEventEndDay - 1);
        }
    }
    else if (lEventStart > lEventEnd) {
        if (revertFunc) {
            revertFunc();
        }
        return false;
    } else if (lEventEnd > lEventStart && lEventEndDay > lEventStartDay) {
        if (revertFunc) {
            revertFunc();
        }
        mActivityNotification.addNotification('Dragging cross days after schedule has already been dropped is not supported.')
        return false;
    }

    return true;
}

function carveOutSchedule_ResizeOverEventDrop(aEvent, delta, revertFunc, jsEvent, ui, view) {
    "use strict";

    if (!cleanMoveFullCalendar(aEvent, revertFunc)) {
        return;
    }

    var updatedEvent = saveUpdatedCarveOutSchedule(aEvent, false, true, true); //save ui already updated
    var lCurrentBlock = $(jsEvent.currentTarget);

    //check if other schedules selected
    if (mEnrolleesData.CarveOutDelete.length > 1) {
        mEnrolleesData.CarveOutDelete.map(function (carveOutSchedule) {
            if (updatedEvent.Event._id != carveOutSchedule.Event._id)
                updateCarveOutDeleteEvent(carveOutSchedule.Event, updatedEvent);
        });

        mEnrolleesData.CarveOutDelete = []; // remove when figure out to add select class back on it.
    }
}

function carveOutAppendExtras(aEvent, aElement) {
    "use strict";
    var lZone = getDataItem(aEvent.data.EntityId, 'Zones');

    aElement.find("div.fc-title").append(' - ' + scheduleZoneTypeFormatter(aEvent.data.ZoneScheduleType));

    if (!lZone) return;

    if (lZone.AddressTypeId !== -1)
        aElement.find("div.fc-content").append(enrolleesCarveOutIconFormatter(lZone.AddressTypeId));
}

function scheduleContentBuilder(aEvent) {
    "use strict";
    var lSchedule = aEvent.data;
    var dateFormat = 'MM/DD/YYYY hh:mm:ss A';
    var lContent = [];
    var lDetails = [{ 'id': 'Name', 'title': localizeText('cEnrolleeDescription') },
                    { 'id': 'StartTime', 'title': localizeText('cAnalysisStart') },
                    { 'id': 'EndTime', 'title': localizeText('cAnalysisEnd') },
                    { 'id': 'UpdatedScheduleLocal', 'title': localizeText('cEnrolleeScheduleUpdateDate') },
                    { 'id': 'UpdatedByAppUserId', 'title': localizeText('cUserUpdatedBy') }];
    if (lSchedule) {
        lContent.push('<table width="100%"><tbody>');
        lContent.push('<tr><td colspan="2"><h2><span class="cEnrolleeDetails">Details</span></h2></td></tr>');
        lDetails.forEach(function (detail) {
            lContent.push('<tr><td class="FormTitle"><span class="">');
            lContent.push(detail.title);
            lContent.push('</span></td>');
            lContent.push('<td class="FormField"><span class="Editable">');
            if (detail.id === 'StartTime') {
                lContent.push(aEvent.start.format(dateFormat));
            } else if (detail.id === 'EndTime' && aEvent.end) {
                lContent.push(aEvent.end.format(dateFormat))
            } else if (detail.id === 'UpdatedByAppUserId') {
                lContent.push(UserNameFormatter(lSchedule.UpdatedByAppUserId))
            } else {
                lContent.push(lSchedule[detail.id]);
            }
            lContent.push('</span></td></tr>');
        });
        lContent.push('<tbody></table>');
    }

    return lContent.join('');
}

function CarveOutRightClickEditOnSave(aEvent, aUpdateTime, aUpdateDesc,aUpdateZone) {
    var textArea = document.getElementById("textAreaUpdate").value;
    var start = moment(document.getElementById("uSchedStart").value, "LT");
    var end = moment(document.getElementById("uSchedEnd").value, "LT");
    var zoneCategory = document.getElementById("zoneCategoryUpdate").value;

    if (textArea !== aEvent.title && aUpdateDesc) {
        aEvent.title = textArea;
        aEvent.data.TitleUpdatedFlag = true
    }
    if (aUpdateZone) {
        aEvent.ScheduleType = parseInt(zoneCategory);
        aEvent.data.ZoneScheduleType = parseInt(zoneCategory);
    }

    if (aUpdateTime) {
        aEvent.start.hours(start.hour())
        aEvent.start.minutes(start.minutes())
        aEvent.end.hours(end.hour())
        aEvent.end.minutes(end.minutes())
    }

    if (aEvent.Status !== 'New')
        aEvent.Status = 'Updated';

    saveUpdatedCarveOutSchedule(aEvent, true, false)
}

function startEndGreater() {
    var start = moment(document.getElementById("uSchedStart").value, "LT");
    var end = moment(document.getElementById("uSchedEnd").value, "LT");

    if (!start.isValid() || !end.isValid()) {
        $('.OkButton').addClass('Disabled')
        return;
    }
    if (start >= end) {
        $('.OkButton').addClass('Disabled')
        $('#startEndGreater').show();
        return;
    } else {
        $('#startEndGreater').hide();
    }

    $('.OkButton').removeClass('Disabled')

}

function displayRightClickEditOption(aEvent) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var displayDate = ""
    var lTitle = "Edit Schedule - " + aEvent.title;
    $('div.qtip:visible').qtip('hide');

    GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', function (aThis) {
        if ($('.OkButton').hasClass('Disabled')) return;
        var allSelected = $('#uSchedAllSelectedTime').is(":checked");
        var allSelectedDesc = $('#uSchedAllSelectedDesc').is(":checked");

        CarveOutRightClickEditOnSave(aEvent, true, true,true);
        if (allSelected || allSelectedDesc) {
            mEnrolleesData.CarveOutDelete.forEach(function (schedule) {
                if(schedule.Event.Id !== aEvent.Id)
                    CarveOutRightClickEditOnSave(schedule.Event, allSelected,allSelectedDesc)
            })

            mEnrolleesData.CarveOutDelete = [];
            $('.fc-time-grid-event').removeClass('prepareForDeleteSoberTrackBlock');
        }
        if(aEvent.data.Id !== -1)
            aEvent.Status = "UpdatedText"
        saveCarveOutScheduleCreated()

        ClosePopup();
    }).appendTo(lButtonBar);

    var lHtml = [];
    lHtml.push('<div id="startEndGreater" class="Alert" style="display:none;">Start Date must be before End Date</div>');

    if (aEvent.data.Id !== -1 && [7, 8, 10].indexOf(aEvent.data.ScheduleType) !== -1) {
        displayDate = "none"
    }

    mEnrolleesData.CarveOutDelete.forEach(function (a) {
        if(a.Event.data.Id !== -1 && [7, 8, 10].indexOf(a.Event.data.ScheduleType) !== -1) {
            displayDate = "none"
        }
    })

    lHtml.push('<table>')
    if (mEnrolleesData.CarveOutDelete.length > 1) {
        lHtml.push('<tr style="display:' + displayDate + '"> <td class="FormTitle"><label for="uSchedAllSelected"> Update All Selected Time</label></td><td class="FormField"><input type="checkbox" id="uSchedAllSelectedTime"/></td>')
    }
    lHtml.push('<tr style="display:' + displayDate +'"> <td class="FormTitle"><label for="uSchedStart"> Start Time </label></td><td class="FormField"><input type="text" id="uSchedStart"/></td>')
    lHtml.push('<tr style="display:' + displayDate + '"> <td class="FormTitle"><label for="uSchedEnd"> End Time </label></td><td class="FormField"><input type="text" id="uSchedEnd"/></td>')
    if (mEnrolleesData.CarveOutDelete.length > 1) {
        lHtml.push('<tr> <td class="FormTitle"><label for="uSchedAllSelected"> Update All Selected Description</label></td><td class="FormField"><input type="checkbox" id="uSchedAllSelectedDesc"/></td>')
    }
    lHtml.push('<tr> <td class="FormTitle"> Description </td> <td class="FormField"  colspan="2"> <textarea id="textAreaUpdate" rows="10" cols="50"></textarea></td>');
    lHtml.push('<tr> <td class="FormTitle"> Zone Category </td> <td class="FormField"  colspan="2">',GetZoneCategoryHtml(),'<div> This option will update all schedules for this zone </div> </td>');
    lHtml.push('</table>');
    
    DisplayPopup(lTitle, lHtml.join(''), lButtonBar, false, true);

    $('#uSchedStart').ptTimeSelect({
        'zIndex': 100000,
        'onFocusDisplay': true,
        'onClose': startEndGreater
    });

    $('#uSchedEnd').ptTimeSelect({
        'zIndex': 100000,
        'onFocusDisplay': true,
        'onClose': startEndGreater
    });

    $("#uSchedStart").val(aEvent.start.format("LT"))
    $("#uSchedEnd").val(aEvent.end.format("LT"))
    //Vulnerability 3256
    document.getElementById("textAreaUpdate").value = veritracks.system.decodeHtml(aEvent.title);
    document.getElementById("zoneCategoryUpdate").value = aEvent.data.ZoneScheduleType
    function GetZoneCategoryHtml(){
        return [
            '<select id="zoneCategoryUpdate" >',
                '<option value="1">',localizeText('cEnrolleeActive'),'</option>',
                '<option value="2">',localizeText('cEnrolleeSilent'),'</option>',
                '<option value="3">',localizeText('cEnrollee911'),'</option>',
            '</select>'
        ].join(' ');
    }
    
}

function carveOutSchedule_AfterRender(aEvent, aElement) {
    "use strict";
    var lCalendarId = mEnrolleesControls.carveOutSchedule.calendarId();
    var lDefaultMy = 'left top';
    var lDefaultAt = 'right top';

    aElement.find(".fc-bg").css("pointer-events", "none");

    aElement[0].addEventListener("contextmenu", function (e) {
        e.preventDefault();
        displayRightClickEditOption(aEvent);
    });

    if ([1, 8].indexOf(aEvent.ScheduleType) !== -1)
        carveOutAppendExtras(aEvent, aElement);

    $('#uRemoveCarveOutButton').addClass('Disabled');

    // append qtip to each element.
    aElement.qtip({
        content: {
            text: scheduleContentBuilder(aEvent)
        },
        hide: { when: { aEvent: 'unfocus' } },
        position: {
            my: lDefaultMy,
            at: lDefaultAt,
            adjust: {
                method: 'shift'
            },
            viewport: $(window)
            //viewport: aId
        },
        show: {
            delay: 800
        },
        style: 'qtip-bootstrap qtip-no-width'
    });
}

function filterTargetOnQtip(aThis) {
    "use strict";
    var lId = aThis.id.replace('ScheduleFilter', '');
    var lScheduleTarget = '#' + lId + 'ScheduleTarget';
    var lFilter = $('#' + aThis.id).val();
    var carveOut = mEnrolleesControls.carveOutSchedule.getRawDataSource().find(function (schedule) {
        return schedule._id === lId;
    });

    $(lScheduleTarget).find('option').remove().end();

    if (lFilter.length == 0) {
        $(lScheduleTarget).append(mEnrolleesData.qtipScheduleTargetClean);
    } else {
        var lNewSelects = mEnrolleesData.qtipScheduleTargetClean.filter(function (target) {

            if (target.text.toUpperCase().indexOf(lFilter.toUpperCase()) >= 0)
                return target;
        });

        if (lNewSelects.length > 0)
            $(lScheduleTarget).append(lNewSelects);
    }

    $(lScheduleTarget).val($(lScheduleTarget + ' option:first').val());
    $(lScheduleTarget).val(carveOut.data.EntityId);

}

function setUpScheduleEditOptions(aElement) {
    "use strict";
    var lId = aElement.qtip('api').options.content.eventId;

    var carveOut = mEnrolleesControls.carveOutSchedule.getRawDataSource().find(function (schedule) {
        return schedule._id === lId;
    })

    function populateZoneCategory() {
        var lZoneCategoryId = document.getElementById(lId + 'ZoneCategory');

        lZoneCategoryId.options.length = 0;

        var option = document.createElement("option");
        option.text = localizeText('cEnrolleeActive');
        option.value = 1;
        lZoneCategoryId.append(option);

        var option = document.createElement("option");
        option.text = localizeText('cEnrolleeSilent');
        option.value = 2;
        lZoneCategoryId.append(option);

        var option = document.createElement("option");
        option.text = localizeText('cEnrollee911');
        option.value = 3;
        lZoneCategoryId.append(option);

        lZoneCategoryId.value = carveOut.data.ZoneScheduleType;
    }

    function populateScheduleType() {
        var lScheduleTypeId = document.getElementById(lId + 'ScheduleType');


        lScheduleTypeId.options.length = 0;

        var option = document.createElement("option");
        option.text = localizeText('cEnrolleeReoccurring');
        option.value = true;
        lScheduleTypeId.append(option);

        var option = document.createElement("option");
        option.text = localizeText('cEnrolleeOneTime');
        option.value = false;
        lScheduleTypeId.append(option);

        lScheduleTypeId.value = carveOut.data.IsRecurring;
    }

    function setUpCarveOutUpdateTimes() {
        var startId = '#' + lId + 'start';
        var endId = '#' + lId + 'end';

        $(startId).timeEntry({ beforeSetTime: customCarveOutTimeRange });
        $(endId).timeEntry({ beforeSetTime: customCarveOutTimeRange });


        $(startId).val(carveOut.start.format('hh:mmA'));

        if (carveOut.end) {
            $(endId).val(carveOut.end.format('hh:mmA'));
        } else {
            var lEnd = moment(carveOut.start);

            lEnd.add('hours', 23).add('minutes', 59);
            $(endId).val(lEnd.format('hh:mmA'));
        }


        $('#' + lId + 'desc').val(carveOut.title ? carveOut.title : "");

    }

    function populateScheduleTarget() {
        mEnrolleesData.qtipScheduleTargetClean = carveOutScheduleTarget_Populate(carveOut.data.ScheduleType.toString(), '#' + lId + 'ScheduleTarget');

        $('#' + lId + 'ScheduleTarget').val(carveOut.data.EntityId);
    }

    if ([1, 8].indexOf(carveOut.ScheduleType) !== -1) {
        populateZoneCategory();
    } else {
        $("#" + lId + 'ZoneCategory').remove();
    }

    setUpCarveOutUpdateTimes();
    // populateScheduleType();
    // populateScheduleTarget();
}

function customCarveOutTimeRange(oldTIme, newTime) {
    var focused = '#' + document.activeElement.id;

    var lNewMoment = moment(newTime);
    if (focused.includes('start')) {
        var lEnd = focused.replace('start', 'end');
        var lEndMoment = moment($(lEnd).timeEntry('getTime'));

        if (lNewMoment.hours() >= lEndMoment.hours() && lNewMoment.minutes() >= lEndMoment.minutes()) {
            return oldTIme;
        }
    } else {
        var lStart = focused.replace('end', 'start');
        var lStartMoment = moment($(lStart).timeEntry('getTime'));

        if (lNewMoment.hours() <= lStartMoment.hours() && lNewMoment.minutes() <= lStartMoment.minutes()) {
            return oldTIme;
        }
    }

    return newTime;
}

function UpdateCarveOutOnClick(aId) {
    var lDescription = $('#' + aId + 'desc').val();
    var lStart = $('#' + aId + 'start').val();
    var lEnd = $('#' + aId + 'end').val();
    var lParent = $('#' + aId + 'desc').parent().closest('div').attr('id').replace('-content', '');
    var lScheduleZoneCategory = $('#' + aId + 'ZoneCategory').val();
    //var lScheduleType = $('#' + aId + 'ScheduleType').val();
    //var lScheduleTarget = $('#' + aId + 'ScheduleTarget').val();
    //var lScheduleTargetTitle = $('#' + aId + 'ScheduleTarget' + ' option:selected').text();

    var updateCarveOut = mEnrolleesControls.carveOutSchedule.getRawDataSource().find(function (schedule) {
        return schedule._id === aId;
    });

    if (updateCarveOut) {
        var lStartMoment = moment(lStart, "h:mm: A");
        var lEndMoment = moment(lEnd, "h:mm: A");

        updateCarveOut.start.hours(lStartMoment.hours());
        updateCarveOut.start.minutes(lStartMoment.minutes());
        if (!updateCarveOut.end) {
            updateCarveOut.end = moment(updateCarveOut.start);
            updateCarveOut.end.add('hours', 23).add('minutes', 59);
        }
        updateCarveOut.end.hours(lEndMoment.hours());
        updateCarveOut.end.minutes(lEndMoment.minutes());
        updateCarveOut._end = updateCarveOut.end;
        updateCarveOut.data.ZoneScheduleType = parseInt(lScheduleZoneCategory);
        //updateCarveOut.data.IsRecurring = lScheduleType == "true";
        //updateCarveOut.data.EntityId = parseInt(lScheduleTarget);

        if (updateCarveOut.title !== lDescription) {
            updateCarveOut.title = lDescription;
            updateCarveOut.data.TitleUpdatedFlag = true;
        } else if (!updateCarveOut.data.TitleUpdatedFlag) {
            var lParentEntity = updateCarveOut.parentEntity;
            if (updateCarveOut.data.Id !== -1) {
                lParentEntity = updateCarveOut.parentEntity || updateCarveOut.title.split("-").slice(3).join('-');
            }
            var lTitle = CarveOutScheduleTitle(updateCarveOut.start,
                updateCarveOut.end,
                updateCarveOut.data.ScheduleType,
                updateCarveOut.data.IsRecurring,
                lParentEntity
            );
            updateCarveOut.title = lTitle
        }

        updateCarveOut.color = getScheduleColor({
            IsReocurring: updateCarveOut.data.IsRecurring,
            TargetTypeId: updateCarveOut.data.ScheduleType,
            EntityId: updateCarveOut.data.EntityId,
            ZoneScheduleType: updateCarveOut.data.ZoneScheduleType
        });

        saveUpdatedCarveOutSchedule(updateCarveOut, true, true); //save and update ui
    }


    //remove qtip to not leave stale data
    var lQtip = $('#' + lParent).qtip('api');

    if (lQtip) {
        lQtip.destroy(true);

    }
}

function disableCarveOutSchedules(aDisabled) {
    mEnrolleesControls.carveOutSchedule.getRawDataSource().map(function (schedule) {
        schedule.editable = aDisabled
    });
}

function saveCarveOutScheduleUserPreference_OnChange(self) {
    "use strict";
    var lUserPreferences = getUserPreferences(4);

    if (!isNullOrUndefined(lUserPreferences['CarveOutPreference'])) {
        var lCarveOutPreference = lUserPreferences['CarveOutPreference'].Value == 1 ? true : false;

        if (lCarveOutPreference !== self.checked) {
            $('#uSaveCarveOutPreferencesButton').removeClass('Disabled');
        } else {
            $('#uSaveCarveOutPreferencesButton').addClass('Disabled');
        }
    } else {
        if (self.checked) {
            $('#uSaveCarveOutPreferencesButton').removeClass('Disabled');
        } else {
            $('#uSaveCarveOutPreferencesButton').addClass('Disabled');
        }
    }
}

function displayDSTSchedules() {
    return veritracks.system.clientSetting("ScheduleDSTFlag")
}

function displayOldScheduleUILoggedInOri(aEnrolleeId) {
    "use strict";

    if (aEnrolleeId && aEnrolleeId > 0) {
        var lEnrollee = GetEnrollee(aEnrolleeId);
        return checkOrganizationProperty(lEnrollee.OrganizationId, 'display_old_schedule_ui') == 'Y'
    }

    return gUserDetails.AvailableOrganizationIds.filter(function (ori) {
        return checkOrganizationProperty(ori, 'display_old_schedule_ui') == 'N'
    }).length > 0 ? false : true
}

function getCarveOutPreference(aSkip, ignorePreference) {
    var lUserPreferences = getUserPreferences(4);
    var lPreference = false;

    if (displayOldScheduleUILoggedInOri(mEnrolleesData.OffenderCurrentId) && !ignorePreference) {
        return false;
    }

    if (!isNullOrUndefined(lUserPreferences['CarveOutPreference'])) {
        lPreference = lUserPreferences['CarveOutPreference'].Value == 1 ? true : false;
    }
    if (aSkip) {
        return lPreference;
    }

    if (lPreference) {
        if (mEnrolleesData.ScheduleToggleSelected) {
            return false;
        } else {
            return true;
        }
    } else {
        if (mEnrolleesData.ScheduleToggleSelected) {
            return true;
        } else {
            return false;
        }
    }
}

function saveCarveOutScheduleUserPreference(self) {
    "use strict";
    if ($(self).hasClass('Disabled')) {
        return false;
    }
    var lPreferenceCheck = $('#uCarveOutEnabledPreference').is(':checked') ? 1 : 0;
    var lPreference = new UserPreference();
    lPreference.Id = gUserDetails.UserId;
    lPreference.Value = lPreferenceCheck;
    lPreference.UserPreferenceType = 4;
    lPreference.ColumnName = 'CarveOutPreference';

    writeUserPreferences([lPreference], function CarveOutUserPreference_OnSuccess() {
        var lMode = lPreferenceCheck ? 'enabled' : 'disabled';
        mActivityNotification.addNotification('Carve out mode ' + lMode);

        if (window.confirm("Refresh page for change to user preferences to take effect") == true) {
            location.reload(true);
        }
    });

}

function findMatchingTimeInSchedule(aStart, aEnd, allowDisabled) {
    "use strict";
    var diff
    var lMatches = mEnrolleesControls.carveOutSchedule.getRawDataSource().filter(function (rawData) {
        return moment(rawData.start.format()) <= aStart && aEnd <= moment(rawData.end.format()) && rawData.Type != 'TimeOut' && (rawData.className.indexOf("CalendarDisabled") == -1 || allowDisabled)
    });

    return lMatches;
}

function getUpperBoundTimeInSchedule(aSchedule){
    return mEnrolleesControls.carveOutSchedule.getRawDataSource().find(function (rawData) {
        if (rawData.end) {
            return rawData.end.diff(aSchedule.start) === 0 && rawData.data.EntityId == aSchedule.data.EntityId && rawData.Type != 'TimeOut'
        }
    });
}

function getLowerBoundTimeInSchedule(aSchedule){
    return mEnrolleesControls.carveOutSchedule.getRawDataSource().find(function (rawData) {
        if (rawData.start) {
            return rawData.start.diff(aSchedule.end) === 0 && rawData.data.EntityId == aSchedule.data.EntityId && rawData.Type != 'TimeOut'
        }
    });
}

function deleteCarveOutSavedSchedule(aSchedules) {
    "use strict";
    var lDeletes = [];
    var processed = [];
    var lRegularDeletes = [];
    var lProcessedDeletes = [];
    var lDisableDuplicates = [];

    function checkIfRegularDeletes(id) {
        return aSchedules.find(function (a) {
            return a.data.Id == id;
        })

    }

    aSchedules.forEach(function (schedule) {
      if (schedule.Type === 'TimeOut') {
          var lUpper = getUpperBoundTimeInSchedule(schedule);
          var lLower = getLowerBoundTimeInSchedule(schedule);
          if(schedule.data.IsRecurring){
            // check if lower or upper are part of delete as well if they are then delete as regular schedule.
            if (!lUpper || !lLower || checkIfRegularDeletes(lUpper.data.Id) || checkIfRegularDeletes(lLower.data.Id) || !lLower.data.Id || !lUpper.data.Id) {
                schedule.data.IsActive = false;
                schedule.data.TransactionId = moment().format("YYYYMMDDHHmmss");
                lRegularDeletes[schedule.data.Id] = schedule.data
            } else {
                lDeletes[lUpper.data.Id] = lLower.data.Id; // first id points to next id
            }
          }else {
            if(lUpper){
              lUpper.data.IsActive = false
              lRegularDeletes[lUpper.data.Id] = lUpper.data
            }

            if(lLower){
              lLower.data.IsActive = false
              lRegularDeletes[lLower.data.Id] = lLower.data
            }

            if(schedule){
              schedule.data.IsActive = false
              lRegularDeletes[schedule.data.Id] = schedule.data
            }
          }
      } else {
          schedule.data.IsActive = false;
          schedule.data.TransactionId = moment().format("YYYYMMDDHHmmss");
          lDisableDuplicates[schedule.data.Id] = lDisableDuplicates[schedule.data.Id] ? ++lDisableDuplicates[schedule.data.Id] : 1;
          lRegularDeletes[schedule.data.Id] = schedule.data
      }
  });

    Object.keys(lDeletes).forEach(function (key) {
        if (processed[key]) return;

        var tempKey = key;
        while (lDeletes[tempKey]) {
            processed[tempKey] = true;
            tempKey = lDeletes[tempKey];
        }
        lProcessedDeletes.push({ Id: parseInt(key), SecondId: parseInt(tempKey) })
    })

    lProcessedDeletes = Object.values(lProcessedDeletes).map(function (process) {
        var lTimeOut = new OffenderTimeOutSchedule();
        var lSchedule = getEnrolleeSchedules().find(function(sc){return sc.Id == process.Id})
        lTimeOut.IsActive = 0;
        lTimeOut.TransactionId = moment().format("YYYYMMDDHHmmss");
        lTimeOut.Id = process.Id;
        lTimeOut.SecondId = process.SecondId;
        lTimeOut.EnrolleeId = mEnrolleesData.OffenderCurrentId;
        lTimeOut.EntityId = lSchedule.EntityId;
        lTimeOut.ScheduleTypeId = getTimeOutScheduleType(lSchedule.ScheduleType);
        lTimeOut.TitleUpdatedFlag = 0;

        return lTimeOut;
    })

    var lRegularDeletes = Object.values(lRegularDeletes)

    WriteMultiple(lProcessedDeletes, function (a, b) {
         WriteMultiple(lRegularDeletes, enrolleesCarveOutScheduleWrite_OnSuccess, CarveOutOnSave_Fail, 'deleted', true);
    }, CarveOutOnSave_Fail, 'Deleted', true);
}


function saveUpdatedCarveOutSchedule(aEvent, update, save, dropped) {

    var updateEvent = updateEventDaysAfterChange(aEvent, dropped);
    var lEvent = updateEvent.Event;

    if (update)
        mEnrolleesControls.carveOutSchedule.updateEvent(lEvent);

    $('#uSaveCarveOutButton').removeClass('Disabled'); // update to only save after pressing save button.

    return updateEvent;
}

function getEnrolleeSchedules() {
    "use strict";
    return mEnrolleesData.OffenderSchedules;
}

function getCarveOutPrefix(aType) {
    switch (aType) {
        case 1:
            return 'Z';
        case 2:
            return 'B';
        case 3:
            return 'D';
        case 6:
            return 'A';
    }
}

function getEntity(aEntityId, aScheduleTypeId) {
    var lTarget = mEnrolleesData.SchedulesTargetsClean[getCarveOutPrefix(aScheduleTypeId) + aEntityId];
    if (!lTarget) {
        lTarget = mEnrolleesData.CarveOutTargetsClean.find(function (target) {
            return (target.Id == aEntityId && target.TypeId == aScheduleTypeId)
        })
    }
    return lTarget;
}

function getEntityName(aName) {
    "use strict";
    var lTargets = mEnrolleesData.CarveOutScheduleTargetListView ? mEnrolleesData.CarveOutScheduleTargetListView.getDataSource() : mEnrolleesData.SchedulesTargetsClean;
    var lTarget;
    var Prefix;
    var lRawSchedule = [];

    if (PopupIsOpen()) {
        lRawSchedule = mEnrolleesControls.carveOutSchedule.getRawDataSource().filter(function (schedule) {
            return schedule.data.Name === aName.replace(/_/g, ' ')
        })[0];
        if (lRawSchedule)
            Prefix = getCarveOutPrefix(lRawSchedule.ScheduleType) + lRawSchedule.data.EntityId;
    };
    if (!Prefix) {
        lRawSchedule = getEnrolleeSchedules().filter(function (schedule) {
            return schedule.Name === aName;
        })[0];
        if (lRawSchedule)
            Prefix = getCarveOutPrefix(lRawSchedule.ScheduleType) + lRawSchedule.EntityId;
    }


    if (Prefix) {
        lTarget = lTargets[Prefix];
        if (!lTarget) {
            lTarget = {
                Name: 'Unassigned',
                TypeName: Prefix == 'D-1' ? 'BLUbox' : 'BLUhome'
            }
        }
        return lTarget.Name + ' (' + lTarget.TypeName + ')';
    }

    return '';
}

function saveCarveOutAbsence(aSchedules, aType) {
    "use strict";
    mEnrolleesData.AbsenceSaveHolder = aSchedules.map(function (schedule) {
        var lTimeOut = new OffenderTimeOutSchedule(schedule);
        lTimeOut.StartDate = moment(schedule.StartTime).format('MMDDYYYY');
        lTimeOut.StartTime = moment(schedule.StartTime).format('HHmm');
        lTimeOut.StopTime = moment(schedule.EndTime).format('HHmm');
        return { lTimeOut: lTimeOut, schedule: schedule };
    });

    saveCarveOutRecursively(mEnrolleesData.AbsenceSaveHolder, 0);
}

function finalFilterTimeOutSchedule(aTimeOut, aTimeIns, aEntityId) {
    var lResults = [];


    lResults = aTimeIns.filter(function (a) {
        return a.data.EntityId == aTimeOut.EntityId
    })


    if (lResults.length > 1) {
        lResults = lResults.filter(function (a) {
            return a.className.indexOf("CalendarDisabled") == -1
        })
    }

    lResults.sort(function (a, b) {
        if (a.borderColor < b.borderColor)
            return 1;
        if (a.borderColor > b.borderColor)
            return -1;
        return 0;
    })

    return lResults[0]
}

function saveCarveOutRecursively(aList, aIndex) {
    var object = aList[aIndex];
    if (object) {
        var schedule = object.schedule;
        var timeout = object.lTimeOut;

        var lTimeIn = findMatchingTimeInSchedule(moment(schedule.StartTime), moment(schedule.EndTime), true);
        lTimeIn = finalFilterTimeOutSchedule(timeout, lTimeIn);
        var lEntity = getEntity(lTimeIn.data.EntityId, lTimeIn.data.ScheduleType);

        timeout.Id = lTimeIn.data.Id;
        timeout.EntityId = lEntity.Id;
        timeout.EntityName = lEntity.Name;

        WriteSingle(timeout, function (aParams, aData) {
            var lBuilder = new SumoPredicateBuilder();

            lBuilder.AddNewExpressionConditional('EnrolleeId', mEnrolleesData.OffenderCurrentId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
            lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());

            //4.5 change here - EE
            ReloadEnrolleeSchedules(mEnrolleesData.OffenderCurrentId,
                function (aParams, aData) {
                enrolleesOffenderScheduleCarveReload_OnComplete(aParams, aData);
                saveCarveOutRecursively(aList, ++aIndex);
                }, null, aData);
        }, CarveOutOnSave_Fail, 'saved', true);

        populateAbsenceScheduleTargetList();
    } else {

        mActivityNotification.addNotification('Successfully saved schedule');

    }
}

function enrolleesCarveOutScheduleWrite_OnSuccess(aParams, aData) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder();
    updateScheduleZoneCategory(aData);

    ReloadEnrolleeSchedules(mEnrolleesData.OffenderCurrentId, function (aParams, aData) {
        enrolleesOffenderScheduleCarveReload_OnComplete(aParams, aData);
    }, null, aData);

    switch (aParams) {
        case 'saved':
            mActivityNotification.addNotification('Successfully saved schedule');
            break;
        case 'updated':
            mActivityNotification.addNotification('Successfully updated schedule');
            break;
        case 'deleted':
            mActivityNotification.addNotification('Successfully deleted schedule');
            break;
    }
}

function enrolleesOffenderScheduleCarveReload_OnComplete(aParams, aData) {
    "use strict";
    MyZoneEnrolleesInit(aData); // update my zones list.
    if ($('#uCarveOutScheduleNewTargetSelect').val() == "My") {
        var state = $('#uCarveOutScheduleSelectionSelect').val();
        uCarveOutScheduleTarget_OnChange();
        $('#uCarveOutScheduleSelectionSelect').val(state);

    }

    LockDownExists();
    var lDataSource = getCarveOutSchedules(mEnrolleesData.OffenderCurrentId);
    mEnrolleesControls.carveOutSchedule.setDataSource(lDataSource);
    //buildInitialBackgroundEvents('timein');
    enrolleesOffenderScheduleCache_OnComplete(null, null, aParams);
    if (aData.length == 0) {
        $('#uWipeAllButton').addClass('Disabled');
    } else {
        $('#uWipeAllButton').removeClass('Disabled');
    }
}

function checkIsCurrentDay(aSchedule) {
    if (aSchedule.IsSunday)
        return moment().weekday() == 0
    if (aSchedule.IsMonday)
        return moment().weekday() == 1
    if (aSchedule.IsTuesday)
        return moment().weekday() == 2
    if (aSchedule.IsWednesday)
        return moment().weekday() == 3
    if (aSchedule.IsThursday)
        return moment().weekday() == 4
    if (aSchedule.IsFriday)
        return moment().weekday() == 5
    if (aSchedule.IsSaturday)
        return moment().weekday() == 6


    return false
}

function checkCurrentDaySchedule(aSchedule) {
    "use strict";
    if (!checkIsCurrentDay(aSchedule)) return 0;
    var filtered = mEnrolleesControls.carveOutSchedule.getRawDataSource().filter(function (schedule) {
        return schedule.data.IsRecurring && schedule.data.EntityId == aSchedule.EntityId && schedule.end.diff(schedule.start) / 60000 == 1439
    });
    return filtered.length == 7 ? 1 : 0;
}


function saveCarveOutScheduleCreated(self) {
    "use strict";

    if ($(self).hasClass('Disabled')) {
        return false;
    }
    var lTimeZone;

    var lTimeOut = [];
    var lTimeIn = [];
    var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId)
    mEnrolleesControls.carveOutSchedule.getRawDataSource().forEach(function (schedule) {
        var lSchedule = schedule.data;
        //Vulnerability 3256
        schedule.title = veritracks.system.encodeHtml(schedule.title);
        if (!lTimeZone)
            lTimeZone = getEnrolleeTimeZone(lSchedule.EnrolleeId);


        lSchedule.Name = schedule.title;
        lSchedule.TransactionId = moment().format("YYYYMMDDHHmmss");

        if (schedule.Type == "TimeIn") {
            lSchedule.StartTime = convertTimeToUTC(moment(lSchedule.StartTime).toDate(), lTimeZone.TimeZoneName);
            lSchedule.EndTime = convertTimeToUTC(moment(lSchedule.EndTime).toDate(), lTimeZone.TimeZoneName);
            lSchedule.CreateAutoExceptionFlag = checkCurrentDaySchedule(lSchedule);

            if (lSchedule.CreateAutoExceptionFlag) {
                if(checkOrganizationProperty(lEnrollee.OrganizationId, 'display_old_schedule_ui') === 'Y')
                    lSchedule.CreateAutoExceptionFlag = 0
            }
        }
        if (schedule.Type == "TimeOut" && schedule.Status === 'Updated') {
            lSchedule.StartTime = convertTimeToUTC(moment(lSchedule.StartTime).toDate(), lTimeZone.TimeZoneName);
            lSchedule.EndTime = convertTimeToUTC(moment(lSchedule.EndTime).toDate(), lTimeZone.TimeZoneName);
            lTimeOut.push(lSchedule);
        }
        if (schedule.Type == "TimeOut" && schedule.Status === 'UpdatedText') {
            lSchedule.StartTime = convertTimeToUTC(moment(lSchedule.StartTime).toDate(), lTimeZone.TimeZoneName);
            lSchedule.EndTime = convertTimeToUTC(moment(lSchedule.EndTime).toDate(), lTimeZone.TimeZoneName);
            lTimeIn.push(lSchedule);
        }
        else if (schedule.Type == "TimeIn" && schedule.Status) {
            lTimeIn.push(lSchedule);
        } else if (schedule.Type == "TimeOut" && schedule.Status) {
            lTimeOut.push(lSchedule);
        }
    });

    $('#uSaveCarveOutButton').addClass('Disabled');
    mActivityNotification.addNotification('saving....');


    WriteMultiple(lTimeIn, function (aParams, aData) {
        CarveOutOnSave_Success(aParams, aData);
        if (lTimeOut.length > 0) {
            saveCarveOutAbsence(lTimeOut, 'saved');
        } else {
            enrolleesCarveOutScheduleWrite_OnSuccess(aParams, aData);
        }
    }, CarveOutOnSave_Fail, 'saved', true);
}

function CarveOutOnSave_Success(aParams, aData) {
    "use strict";
    var lCalendarId = mEnrolleesControls.carveOutSchedule.calendarId();

    mActivityNotification.addNotification('Schedule ' + aParams + '!');
    // update full calendar
    FixDates(aData);

    aData.map(function (schedule) {
        var lRawSchedule = mEnrolleesControls.carveOutSchedule.getRawDataSource().find(function (raw) {
            return raw.title === schedule.Name;
        })

        if (lRawSchedule) {
            lRawSchedule.data = schedule;
            lRawSchedule.Id = schedule.Id;
        }

        var lSchedule = mEnrolleesData.OffenderSchedules.find(function (id) {
            id == schedule.Id;
        })

        lSchedule = schedule;
    })
   // enrolleesCarveOutScheduleWrite_OnSuccess(aParams, aData);
}

function CarveOutOnSave_Fail(aParams, aData) {
    "use strict";
    mActivityNotification.addNotification('Schedule save failed');
}

function CarveOutSchedule_SelectAllowHandler(aSelectOptions) {
    "use strict";
    var lDeviceSelected = getDeviceSelectedTarget();

    if (!lDeviceSelected) return true;

    if (aSelectOptions.end.hour() != aSelectOptions.start.hour()) {
        if (lDeviceSelected.TypeId === 6) //check in schedules
            return false;
    }

    return true;
}

// need to make changes here
function CarveOutSchedule_SelectHandler(aStart, aEnd) {
    "use strict";
    var lDontSelect = false;
    var lSelected = mEnrolleesData.CarveOutScheduleTargetListView.selectedDataItem();
    var lTimeOutWindow = $('#timeouton').is(":checked");
    var lScheduleType,
    lReocurring = $('#uCarveOutScheduleType select').val() == 'true' ? true : false,
    lTravelSchedule = false,
    lSelectionId,
    lSelectionText,
    lZoneCategory = $('#uCarveOutScheduleZoneCategory select').val(),
    lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId),
    lTimeZone = getEnrolleeTimeZone(lEnrollee.Id),
    lEventMulti;
    var allDays = [];
    var length = 0;
    var lDeviceSelected = getDeviceSelectedTarget();
   

    if (!$('#TravelScheduleLabel').hasClass('DisabledDiv')) {
        lTravelSchedule = $('#uCarveOutScheduleZoneTravel').is(':checked')
    }

    if (lTimeOutWindow && !aStart.hasTime()) {
        return console.log("Return all day")
    }

    if (lDeviceSelected) lSelected = lDeviceSelected;

    if (lSelected) {
        lSelectionId = lSelected.Id;
        lScheduleType = lSelected.TypeId;
        lSelectionText = lSelected.Name + ' (' + lSelected.TypeName + ')';
    }

    if (!lSelected && !lTimeOutWindow) {
        mActivityNotification.addNotification('No Target Selected....');
        return;
    }
    var IsValidZoneCategory = mEnrolleesControls.ScheduleValidator.IsValid();
    if(!IsValidZoneCategory){
        mActivityNotification.addNotification('No Zone Category Selected');
        return;
    }

    var lEventObjects = [];
    var lEventObject = new FullCalendarCarveOutSchedule(aStart, aEnd, null, lReocurring, null, null, true);
    if (aEnd.diff(aStart, 'minutes') == 30) {
        if ($('.prepareForDeleteSoberTrackBlock').length > 0) {
            mEnrolleesData.CarveOutDelete = [];
            $('.fc-time-grid-event').removeClass('prepareForDeleteSoberTrackBlock');
            return;
        }
    }

    //check if lnewendtime is good
    if (itEndsAtMidnight(lEventObject)) {
        var lMinusMinuteEndTime = moment(lEventObject.end);
        lMinusMinuteEndTime = lMinusMinuteEndTime.add(-1, 'minute');
        lEventObject.end = lMinusMinuteEndTime.toDate();
    }

    //get day difference
    var lStartDay = moment(aStart);
    if (aEnd.format("H") == "0") {
        aEnd.add(-1, "minute")
    }
    var lEndDay = moment(aEnd);
    var lDecisionsArray = [];

    while (lStartDay <= lEndDay) {
        var lEventDay = lStartDay.day();
        var parentSchedule;
        var lText;
        var lEventObject;
        if (!lTimeOutWindow) {
            lEventObject = new FullCalendarCarveOutSchedule(lStartDay, aEnd, getTimeInScheduleType(lScheduleType), lReocurring, lSelectionId, lSelectionText, true, false, lTravelSchedule);
        } else {
            lText = 'Time Out';
            lEventObject = new FullCalendarCarveOutSchedule(lStartDay, aEnd, -1, lReocurring, -1, lText, true, false, lTravelSchedule);
        }
        lEventObject.start = new moment(lEventObject.start);
        lEventObject.end = new moment(lEventObject.end);
        lEventObject.start.month(lStartDay.month());
        lEventObject.end.month(lStartDay.month());
        lEventObject.start.date(lStartDay.date());
        lEventObject.end.date(lStartDay.date());
        lEventObject.start.year(lStartDay.year());
        lEventObject.end.year(lStartDay.year());

        if (lTimeOutWindow) {
            var lMatches = findMatchingTimeInSchedule(lEventObject.start, lEventObject.end);
            if (lMatches.length == 1) {
                parentSchedule = lMatches[0].data;
                lText =  parentSchedule.Name + ' Time Out';

                lEventObject = new FullCalendarCarveOutSchedule(lStartDay, aEnd, getTimeOutScheduleType(parentSchedule.ScheduleType), lReocurring, parentSchedule.EntityId, lText, true);
                lEventObject.start = new moment(lEventObject.start);
                lEventObject.end = new moment(lEventObject.end);
                lEventObject.start.month(lStartDay.month());
                lEventObject.end.month(lStartDay.month());
                lEventObject.start.date(lStartDay.date());
                lEventObject.end.date(lStartDay.date());
                lEventObject.data = new OffenderSchedule();

                lEventObject.data.ScheduleType = getTimeOutScheduleType(parentSchedule.ScheduleType);
                lEventObject.data.EntityId = parentSchedule.EntityId;
                lEventObject.data.ZoneScheduleType = parentSchedule.ZoneScheduleType;
            } else if (lMatches.length > 1) {
                lEventObject.data = new OffenderSchedule();
                lDecisionsArray.push({ matches: lMatches, timeout: lEventObject });
            }
        } else {
            lEventObject.data = new OffenderSchedule();

            lEventObject.data.ScheduleType = getTimeInScheduleType(lScheduleType);
            lEventObject.data.EntityId = lSelectionId;
            lEventObject.data.ZoneScheduleType = lZoneCategory;
            lEventObject.data.Name = lEventObject.parentEntity;
            lEventObject.data.TravelScheduleFlag = lTravelSchedule;
            if (lTravelSchedule) {
                lEventObject.title += " Travel Time"
            }
        }
        lEventObject.data.StartTime = lEventObject.start;
        lEventObject.data.EndTime = lEventObject.end;
        lEventObject.data.EnrolleeId = lEnrollee.Id;
        lEventObject.data.IsRecurring = lReocurring;
        lEventObject.data.OrganizationId = lEnrollee.OrganizationId;
        lEventObject.borderColor = lReocurring ? '' :'Orange'
        if (lEventDay == 0) {
            lEventObject.data.IsSunday = true;
        } else if (lEventDay == 1) {
            lEventObject.data.IsMonday = true;
        } else if (lEventDay == 2) {
            lEventObject.data.IsTuesday = true;
        } else if (lEventDay == 3) {
            lEventObject.data.IsWednesday = true;
        } else if (lEventDay == 4) {
            lEventObject.data.IsThursday = true;
        } else if (lEventDay == 5) {
            lEventObject.data.IsFriday = true;
        } else if (lEventDay == 6) {
            lEventObject.data.IsSaturday = true;
        }

        if (lTimeOutWindow) {
            lEventObject.Type = 'TimeOut';
        } else {
            lEventObject.Type = 'TimeIn';
        }

        lEventObject.Status = 'New';

        if (lEventObject.ScheduleType == 6) {
            lEventObject.editable = false;
            lEventObject.durationEditable = false;
        }
        if (lEventObject.data.ScheduleType && lEventObject.data.ScheduleType !== -1) {
            lEventObjects.push(lEventObject);
        } else if (lDecisionsArray.length == 0) {
            mActivityNotification.addNotification('Must Create Timeout within Timein block on ' + lStartDay.format('dddd'))
        }
        lStartDay.add(1, 'days');
    }
    $(mEnrolleesControls.carveOutSchedule.calendarId()).fullCalendar('renderEvents', lEventObjects, true);


    // need to check if override and should ask user if they want to create one time schedules for other recurring schedules.
    if (lDecisionsArray.length > 0) {
        DisplayTimeOutCreationBox(lDecisionsArray, lEventObjects);
    } else {
        if (!lReocurring) {
            checkOneTimePopup(lEventObjects);
        }
    }
    // need to update the recurring schedule to be semi disabled.
    $('#uRemoveCarveOutButton').addClass('Disabled');

    $('#uSaveCarveOutButton').removeClass('Disabled');
    $('div.qtip:visible').qtip('hide');
    
}

function DisplayTimeOutCreationBox(aDecisionsArray, aEventObjects) {
    "use strict";
    var lHtml = [];
    var lButtonBar = GenerateButtonCommandBar();
    var lReocurring = $('#uCarveOutScheduleType select').val() == 'true' ? true : false;

    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeContinue'), 'Continue', function () {
        var lEvents = createTimOutFromPopup(aDecisionsArray);

        if (!lReocurring) {
            checkOneTimePopup(aEventObjects.concat(lEvents));
        }
    }));

    lHtml.push('<div style="padding-bottom:10px"><span> Please select the corresponding Time Ins for the Time Outs where there are multiple schedules that cover the Time Out.</span></div>')
    lHtml.push('<div id="uCorrespondTimeIn" style="max-height: 400px;overflow-y: auto">');
    aDecisionsArray.forEach(function (decision) {
        var timeout = decision.timeout;
        var matches = decision.matches;
        lHtml.push('<h3>');
        lHtml.push(timeout.title);
        lHtml.push('</h3>');
        lHtml.push('<div>');
        lHtml.push('<ul class="radio" style="background:#eff5f5">');
        matches.forEach(function(match){
            lHtml.push('<li style="list-style:none"><label><input style="margin-right:10px" type="radio" name="' + timeout.title + '" value="' + match.Id + '" />' + match.title + '</label></li>')
        })
        lHtml.push('</ul>')
        lHtml.push('</div>');

    })
    lHtml.push('</div>');

    DisplayPopup('Select Corresponding Time Ins', '<div>' + lHtml.join('') + '</div>', lButtonBar, false, true);
    $('.ContinueButton').addClass('Disabled');
    $("#uCorrespondTimeIn input[type=radio]").on('click', function () {
        if ($('#uCorrespondTimeIn input[type=radio]:checked').length === aDecisionsArray.length) {
            $('.ContinueButton').removeClass('Disabled');
        } else {
            $('.ContinueButton').addClass('Disabled');
        }

    });
}


function createTimOutFromPopup(aDecisionsArray) {
    var lEvents = [];
    var lSelectedArray = [];
    $('#uCorrespondTimeIn input[type=radio]:checked').each(function (t) { lSelectedArray[this.name] = this.value })

    aDecisionsArray.forEach(function (decision) {
        var timeout = decision.timeout;
        var lMatchId = lSelectedArray[timeout.title];

        var lMatch = decision.matches.find(function (match) {
            return match.Id == lMatchId;
        });
        timeout.data.ScheduleType = getTimeOutScheduleType(lMatch.data.ScheduleType);
        timeout.ScheduleType = timeout.data.ScheduleType;
        timeout.data.EntityId = lMatch.data.EntityId;
        timeout.data.ZoneScheduleType = lMatch.data.ZoneScheduleType;


        timeout.title = CarveOutScheduleTitle(timeout.start, timeout.end, timeout.data.ScheduleType, timeout.reocurring, lMatch.title + ' Time Out');

        timeout.color = getScheduleColor({ IsRecurring: timeout.reocurring, TargetTypeId: timeout.data.ScheduleType });
        lEvents.push(timeout);
    })

    $(mEnrolleesControls.carveOutSchedule.calendarId()).fullCalendar('renderEvents', lEvents, true);

    ClosePopup();
    $('#uSaveCarveOutButton').removeClass('Disabled');

    return lEvents;

}

function getTimeInDaySchedules(aReocurring, aEntityId, aDay, scheduleTypes) {
    "use strict";

    var lSchedules = mEnrolleesControls.carveOutSchedule.getRawDataSource().filter(function (schedule) {
        if ([1,2,3].indexOf(schedule.data.ScheduleType) === -1) {
            return false;
        }
        return schedule.reocurring == aReocurring && schedule.data.EntityId == aEntityId && schedule.start.day() == aDay && schedule.className.indexOf("CalendarDisabled") == -1
    });

    return lSchedules;
}

function checkOneTimePopup(lEventObjects) {
    "use strict";
    var lButtonBar = GenerateButtonCommandBar();
    var count = [];

    lEventObjects.forEach(function (event) {
        var t = getTimeInDaySchedules(true, event.data.EntityId, event.start.day());

        t = t.filter(function (s) { if (s.start > event.start || s.end < event.start) { return true } })

        //if (event.Type == "TimeIn" && event.borderColor == "Orange") {
        //    t.push(event)
        //}
        count.push(t.length >= 1);
    })

    if (count.indexOf(true) === -1) return;


    lButtonBar.append(GenerateButton(localizeWrapper('cEnrolleeSave'), 'Save', function () {
      createOneTimeForRecurringSchedules(lEventObjects);
      saveCarveOutScheduleCreated()
    }));

    var lHtml = [];
    lHtml.push('<label><input type="checkbox" id="onetimecheck" checked/>Keep existing schedule and add one-time schedule</label></div>')
    DisplayPopup("One Time Schedule", lHtml.join(), lButtonBar, false, true)
}

function createOneTimeForRecurringSchedules(aEventObjects) {
    "use strict";
    var checked = $('#onetimecheck').is(":checked");
    var lTravelSchedule = false;
    if (!$('#TravelScheduleLabel').hasClass('DisabledDiv')) {
        lTravelSchedule = $('#uCarveOutScheduleZoneTravel').is(':checked')
    }

    var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId);
    if (checked) {
        var objectArray = [];
        aEventObjects.forEach(function (schedule) {
            schedule.Id = Math.random();
            mEnrolleesControls.carveOutSchedule.getRawDataSource().forEach(function (sc) {
                if ([1, 2, 3].indexOf(sc.data.ScheduleType) === -1) return;
                if (!sc.allDay && schedule.start.day() == sc.start.day() && sc.data.EntityId == schedule.data.EntityId) {
                    if ((schedule.start <= sc.start && schedule.end <= sc.start) || schedule.start >= sc.end) {
                        var parentSchedule = sc.data;
                        var lEventObject = new FullCalendarCarveOutSchedule(sc.start, sc.end, getTimeInScheduleType(parentSchedule.ScheduleType), false, parentSchedule.EntityId, null, true, null, lTravelSchedule);

                        lEventObject.start = moment(sc.start);
                        lEventObject.end = moment(sc.end);

                        lEventObject.title = sc.title + ' One Time';
                        lEventObject.data = new OffenderSchedule();

                        lEventObject.data.StartTime = lEventObject.start;
                        lEventObject.data.EndTime = lEventObject.end;
                        lEventObject.data.EnrolleeId = lEnrollee.Id;
                        lEventObject.data.IsRecurring = false;
                        lEventObject.data.OrganizationId = lEnrollee.OrganizationId;
                        lEventObject.Status = 'New';
                        lEventObject.Type = 'TimeIn';
                        lEventObject.data.ScheduleType = getTimeInScheduleType(parentSchedule.ScheduleType);
                        lEventObject.data.EntityId = parentSchedule.EntityId;
                        lEventObject.data.ZoneScheduleType = parentSchedule.ZoneScheduleType;
                        lEventObject.borderColor = 'orange'

                        lEventObject.data.TravelScheduleFlag = lTravelSchedule;
                        if (lTravelSchedule) {
                            lEventObject.title += " Travel Time"
                        }

                        var lEventDay = lEventObject.start.day();

                        if (lEventDay == 0) {
                            lEventObject.data.IsSunday = true;
                        } else if (lEventDay == 1) {
                            lEventObject.data.IsMonday = true;
                        } else if (lEventDay == 2) {
                            lEventObject.data.IsTuesday = true;
                        } else if (lEventDay == 3) {
                            lEventObject.data.IsWednesday = true;
                        } else if (lEventDay == 4) {
                            lEventObject.data.IsThursday = true;
                        } else if (lEventDay == 5) {
                            lEventObject.data.IsFriday = true;
                        } else if (lEventDay == 6) {
                            lEventObject.data.IsSaturday = true;
                        }

                        objectArray[lEventObject.start.format() + lEventObject.end.format()] = lEventObject;

                    }
                }
            })
        })
        $(mEnrolleesControls.carveOutSchedule.calendarId()).fullCalendar('renderEvents', Object.values(objectArray), true);
    }

    ClosePopup();
}
function deleteCarveOutScheduleBlocks(self) {
    if ($(self).hasClass('Disabled')) {
        return false;
    }
    var lCalendarId = mEnrolleesControls.carveOutSchedule.calendarId();

    var lCarveOutArray = mEnrolleesData.CarveOutDelete.slice();
    var deleteArray = [];


    for (var lKey in lCarveOutArray) {
        if (lCarveOutArray.hasOwnProperty(lKey)) {
            var carveOutRemove = lCarveOutArray[lKey].Event;           
            deleteFromCarveOutDeleteArray(carveOutRemove);
            if (carveOutRemove.data.Id > 0) {
                deleteArray.push(carveOutRemove);
            } else {
                $(lCalendarId).fullCalendar('removeEvents', carveOutRemove._id);
            }
        }
    }

    if (deleteArray.length > 0) {
        deleteCarveOutSavedSchedule(deleteArray);
        deleteArray.forEach(function(deleteA){
            $(lCalendarId).fullCalendar('removeEvents', deleteA._id);

        })
    }

    if (mEnrolleesControls.carveOutSchedule.getRawDataSource().length > 0) {
        var lNewSchedulesExist = mEnrolleesControls.carveOutSchedule.getRawDataSource().filter(function (schedule) {
            return schedule.data.Id == -1 || schedule.edited;
        });
        if (lNewSchedulesExist.length == 0)
            $('#uSaveCarveOutButton').addClass('Disabled');

        $('#uRemoveCarveOutButton').addClass('Disabled');
    }
}

function deleteFromCarveOutDeleteArray(aBlock) {
    "use strict";
    if (mEnrolleesData.CarveOutDelete.length) {
        var i = mEnrolleesData.CarveOutDelete.length;
        while (i--) {
            var lScheduleIn = mEnrolleesData.CarveOutDelete[i].Event;
            if (lScheduleIn._id == aBlock._id) {
                mEnrolleesData.CarveOutDelete.splice(i, 1);
            }
        }
    }

    if (mEnrolleesControls.carveOutSchedule.getRawDataSource().length > 0) {
        var lNewSchedulesExist = mEnrolleesControls.carveOutSchedule.getRawDataSource().filter(function (schedule) {
            return schedule.data.Id == -1 || schedule.edited;
        });

        if (lNewSchedulesExist.length == 0) {
            $('#uSaveCarveOutButton').addClass('Disabled');
        }

        $('#uRemoveCarveOutButton').addClass('Disabled');
    }
}


function carveOutSchedule_ClickHandler(aEvent, jsEvent) {
    "use strict";
    //check if already selected for deletion, if it's clicked again it means user probably doesn't wanna delete it anymore
    //so remove class also for right click
    var lCurrentBlock = $(jsEvent.currentTarget);
    if (lCurrentBlock.hasClass('prepareForDeleteSoberTrackBlock')) {
        lCurrentBlock.removeClass("prepareForDeleteSoberTrackBlock");
        deleteFromCarveOutDeleteArray(aEvent);
        mActivityNotification.addNotification(localizeWrapper('cCarveOutScheduleNotSelected'));
    } else {
        lCurrentBlock.addClass("prepareForDeleteSoberTrackBlock");
        mEnrolleesData.CarveOutDelete.push({ Event: aEvent, htmlBlock: jsEvent.currentTarget });
        $('#uRemoveCarveOutButton').removeClass('Disabled');
        mActivityNotification.addNotification(localizeWrapper('cCarveOutScheduleSelected'));
        if (schedulesExistThatHaveNotBeenSaved()) {
            mActivityNotification.addNotification(localizeWrapper('cCarveOutScheduleNotSelected'));
        }

    }

    if (mEnrolleesData.CarveOutDelete.length == 0) {
        $('#uRemoveCarveOutButton').addClass('Disabled');
    }
}

/*****************************************/
/*****Create Schedule Design Rules********/
/*****************************************/
function carveOutScheduleDesignRules_ControlInit() {
    "use strict";
    var lSchedule = mEnrolleesData.SchedulesEditItem,
      lUserPreferences = getUserPreferences(4),
      lPrefix = 'Z',
      lEnrolleeId = mEnrolleesData.OffenderCurrentId,
      lDeviceAssignments,
      lHasBluPlus = bluPlusCheck(lEnrolleeId),
      lAbsencesExist = absencesExist(lEnrolleeId),
      lHasBluHome = false,
      lHasDeviceCluster = false,
      lHasBluTag = false,
      lDevice,
      lBuilder = new SumoPredicateBuilder(),
      lZone,
      lHtml = [],
      lItem,
      lKey,
      lScheduleTargetIds = [],
      lUserPreferencesAbsences = getCarveOutPreference(),
      lScheduleTargets = {},
      lCategoryZoneProperty =veritracks.core.GetOriProperty(getDataItem(mEnrolleesData.OffenderCurrentId, 'Enrollees').OrganizationId, 'schedule_zone_risk_level')?? -1;


    lDeviceAssignments = gCurrentDeviceAssignment[lEnrolleeId];

    if (lHasBluPlus) {
        lScheduleTargetIds.push(3);

    } else if (isNullOrUndefined(lDeviceAssignments) || lDeviceAssignments.length === 0) {
        lScheduleTargetIds.push(1, 2, 3, 6, 'My');
    } else {
        for (lKey in lDeviceAssignments) {
            if (lDeviceAssignments.hasOwnProperty(lKey)) {
                lItem = lDeviceAssignments[lKey];
                lDevice = getDataItem(lItem.Id, 'Devices');
                if ([104, 109].indexOf(lDevice.ProductId) !== -1) {
                    lHasBluHome = true;
                } else if (lDevice.ProductId === 103 || lDevice.ProductId === 141 || lDevice.ProductId === 151) { //artf79146 -- need to change device logic to be centralized on what a certain device has access too. EE 11/1/2016
                    lHasBluTag = true;
                }
            }
        }
        lBuilder.AddNewExpressionConditional('TypeId', 3, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        lDeviceAssignments = query(mEnrolleesData.SchedulesTargetsClean, lBuilder.RootExpression);
        lHasDeviceCluster = (!isNullOrUndefined(lDeviceAssignments) && count(lDeviceAssignments) > 0);
    }

    if (lHasBluTag) {
       lScheduleTargetIds.push(1, 'My');
    }
    if (lHasBluHome) {
        lScheduleTargetIds.push(2);
    }
    if (lHasDeviceCluster) {
        lScheduleTargetIds.push(3);
    }

    var lBuild = new SumoPredicateBuilder();

    lBuild.AddNewExpressionConditional('Id', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());


    lScheduleTargets = query(getDataItems('ScheduleType'), lBuild.RootExpression);

    var lScheduleTargetTypes = {};

    lScheduleTargets.map(function (target) {
        if (target.Id ===1) {
            lScheduleTargetTypes['My ' + target.Description + "s"] = 'My';
        }
        lScheduleTargetTypes[target.Description] = target.Id;
    });
    populateDropDown('uCarveOutScheduleNewTargetSelect', lScheduleTargetTypes, false)
    $('#uCarveOutScheduleNewTargetSelect').val(1);

    var lScheduleType = {};

    lScheduleType[localizeText('cEnrolleeReoccurring')] = true;
    lScheduleType[localizeText('cEnrolleeOneTime')] = false;

    populateDropDown('uCarveOutScheduleTypeSelect', lScheduleType, false)

    var lZoneCategories = {};
    lZoneCategories[localizeText('cEnrolleeActive')] = 1;
    lZoneCategories[localizeText('cEnrolleeSilent')] = 2;
    lZoneCategories[localizeText('cEnrollee911')] = 3;

    populateDropDown('uCarveOutScheduleZoneCategorySelect', lZoneCategories, true)
    
    $('#uCarveOutScheduleZoneCategorySelect').val(lCategoryZoneProperty);
    mEnrolleesControls.ScheduleValidator = new Validator('timeinmode', mRegexValidation);
    

    mEnrolleesData.CarveOutScheduleTargetListView = new sumo.controls.CardView('uCarveOutScheduleTargetListView',
        'uCarveOutScheduleTargetListViewHolder',
        {
            'cardTemplate': 'Interface/Enrollees.Offenders.Profile.Schedules.Dialog.Card.Template.htm',
            'selectMethod': 'single',
            'canUnselect': true,
            'cssClass': 'VeritracksCardView'
        });

    mEnrolleesData.CarveOutScheduleTargetListView.bind('selectedchanged', uCarveOutScheduleTargetListView_OnSelectChange);


    uCarveOutScheduleTarget_OnChange();
}

$(document).on('keyup', "#uCarveOutScheduleSelection input[type='text']", function () {
    "use strict";
    var lFilter = $("#uCarveOutScheduleSelection input[type='text']").val()

    $('#uCarveOutScheduleSelectionSelect').find('option').remove().end();

    if (lFilter.length == 0) {
        $('#uPopScheduleTarget').addClass('Disabled');
        $('#uCarveOutScheduleSelectionSelect').append(mEnrolleesData.CarveOutScheduleTargetClean);
    } else {
        var lNewSelects = mEnrolleesData.CarveOutScheduleTargetClean.filter(function (target) {

            if (target.text.toUpperCase().indexOf(lFilter.toUpperCase()) >= 0 && target.value !== "-1")
                return target;
        });

        if (lNewSelects.length > 0) {
            $('#uCarveOutScheduleSelectionSelect').append(lNewSelects);
            $('#uPopScheduleTarget').removeClass('Disabled');
        } else {
            $('#uPopScheduleTarget').addClass('Disabled');
        }
    }

    $("#uCarveOutScheduleSelectionSelect").val($("#uCarveOutScheduleSelectionSelect option:first").val());


});

function uCarveOutDeviceScheduleSelection_OnChange() {
    "use strict";
    var lDeviceSelected = getDeviceSelectedTarget();
    var IsValidZoneCategory = mEnrolleesControls.ScheduleValidator.IsValid();
    if (lDeviceSelected && IsValidZoneCategory) {
        var lSelected = mEnrolleesData.CarveOutScheduleTargetListView.selected();
        mEnrolleesData.CarveOutScheduleTargetListView.selected(lSelected); //unselects
        if (lDeviceSelected.TypeId === 6) {
            $('#uSave247Schedule').addClass('Disabled');
        } else {
            $('#uSave247Schedule').removeClass('Disabled');

        }
    } else {
        $('#uSave247Schedule').addClass('Disabled');
    }
}

function uCarveOutScheduleSelection_OnChange() {
    "use strict";
    var lTargetType = $('#uCarveOutScheduleSelectionSelect').val();
    var IsValidZoneCategory = mEnrolleesControls.ScheduleValidator.IsValid();
    if (lTargetType == "-1" && IsValidZoneCategory) {
        $('#uPopScheduleTarget').addClass('Disabled');
    } else {
        $('#uPopScheduleTarget').removeClass('Disabled');
    }
}

function uCarveOutScheduleTarget_OnChange() {
    "use strict";
    var lTargetType = $('#uCarveOutScheduleNewTargetSelect').val();
    mEnrolleesData.CarveOutScheduleTargetClean = carveOutScheduleTarget_Populate(lTargetType, "#uCarveOutScheduleSelectionSelect");


    if (['1', '8', 'My'].indexOf(lTargetType) == -1) {
        $('#uCarveOutScheduleZoneCategory').hide();
    } else {
        $('#uCarveOutScheduleZoneCategory').show();
    }
}
function uCarveOutScheduleTargetListView_OnSelectChange() {
    "use strict";
    var lSelected = mEnrolleesData.CarveOutScheduleTargetListView.selected();

    if (lSelected) {
        $("#uCarveOutDeviceScheduleSelectionSelect option:first").attr('selected', 'selected');
        var lZoneValid = mEnrolleesControls.ScheduleValidator.IsValid();
        if(lZoneValid){
            $('#uSave247Schedule').removeClass('Disabled');
        }
        if (lSelected.indexOf('Z') !== -1) {
            var lZoneId = lSelected.replace('Z', '')
            var lZone = GetZone(lZoneId)

            if (lZone.Type == 2) {
                $('#TravelScheduleLabel').addClass('DisabledDiv');
            } else {
                $('#TravelScheduleLabel').removeClass('DisabledDiv');
            }
        } else {
            $('#TravelScheduleLabel').addClass('DisabledDiv');
        }


    } else {
        $('#TravelScheduleLabel').addClass('DisabledDiv');
        $('#uSave247Schedule').addClass('Disabled');
    }

}

function carveOutScheduleTarget_Populate(aTargetType, aSelector) {
    "use strict";
    var lBuilder = new SumoPredicateBuilder(),
        lList = [],
        lTargetType = scheduleTargetTypeFormatter(aTargetType);

    var lSort = new SortExpression();
    var lDataSource = mEnrolleesData.CarveOutScheduleTargetListView.getDataSource();

    lBuilder.AddNewExpressionConditional('TypeId', parseInt(lTargetType), false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());  
    if (aTargetType === 'My') {
        lBuilder.AddNewExpressionConditional('Id', mEnrolleesData.EnrolleeZoneIdList, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    }

    lList = query(mEnrolleesData.SchedulesTargetsClean, lBuilder.RootExpression);

    lSort.addAscendingColumn('Name');

    lList = lSort.sort(lList);

    var lScheduleOptions = [];

    // default option
    lScheduleOptions.push(new Option(localizeText('cPleaseSelect') + '....', -1));

    if (Object.keys(lList).length > 0) {
        for (var lKey in lList) {
            if (lList.hasOwnProperty(lKey)) {
                var lAddressName = lList[lKey].AddressType ? " - " + lList[lKey].AddressType : "";
                var lName = lList[lKey].Name + ' (' + lList[lKey].TypeName + lAddressName + ')'
                lScheduleOptions.push(
                    new Option(lName, lList[lKey].Id)
                );
            }
        }
    }

    $('#uPopScheduleTarget').addClass('Disabled');

    $(aSelector).find('option').remove().end().append(lScheduleOptions);


    return lScheduleOptions;
}

function getDeviceSelectedTarget() {
    "use strict";
    var lDeviceId = $('#uCarveOutDeviceScheduleSelectionSelect').val();
    var lDeviceSelected = $('#uCarveOutDeviceScheduleSelectionSelect option:selected').text();
    var lSelectedItem = null;
    if (lDeviceSelected !== 'Please select a device target....') {
        lSelectedItem = mEnrolleesData.SchedulesTargetsClean[lDeviceId]
    }

    return lSelectedItem;
}

function saveAllDayFromAbsence(aThis) {
    "use strict";
    if ($(aThis).hasClass('Disabled')) return;
    var lSelectedItem = mEnrolleesData.CarveOutScheduleTargetListView.selectedDataItem();
    var lSchedule = new OffenderSchedule();
    var lEnrollee = GetEnrollee(mEnrolleesData.OffenderCurrentId);
    var lNow = new Date();
    var lTimeZone = getEnrolleeTimeZone(lEnrollee.Id);
    var lDeviceItem = getDeviceSelectedTarget();

    if (lDeviceItem) lSelectedItem = lDeviceItem;
    var lName = lSelectedItem.Name + ' (' + lSelectedItem.TypeName + ')' + ' 24x7';
    lSchedule.EntityId = lSelectedItem.Id;
    lSchedule.EnrolleeId = lEnrollee.Id;

    lSchedule.IsSunday = true;
    lSchedule.IsMonday = true;
    lSchedule.IsTuesday = true;
    lSchedule.IsWednesday = true;
    lSchedule.IsThursday = true;
    lSchedule.IsFriday = true;
    lSchedule.IsSaturday = true;

    lSchedule.IsRecurring = true;
    lSchedule.Name = lName;
    lSchedule.StartTime = new Date(displayShortDate(lNow) + ' 00:00:00');
    lSchedule.EndTime = new Date(displayShortDate(lNow) + ' 23:59:00');
    lSchedule.TransactionId = moment().format("YYYYMMDDHHmmss");
    if (lSelectedItem.TypeId == 1) {
        var lValue = $('#uCarveOutScheduleZoneCategorySelect').val();
        lSchedule.ZoneScheduleType = parseInt(lValue);
    } else {
        lSchedule.ZoneScheduleType = -1;
    }

    lSchedule.ScheduleType = getTimeInScheduleType(lSelectedItem.TypeId);

    lSchedule.StartTime = convertTimeToUTC(lSchedule.StartTime, lTimeZone.TimeZoneName);
    lSchedule.EndTime = convertTimeToUTC(lSchedule.EndTime, lTimeZone.TimeZoneName);

    mActivityNotification.addNotification('Saving Schedule.....');

    var notification = localStorage.getItem("ezNotification");
    if (lSchedule.ZoneScheduleType == 1 && !notification) {
        var lZone = GetZone(lSchedule.EntityId)
        var lButtonBar = GenerateButtonCommandBar()
        var lHtml = [];

        lHtml.push("<div> Exclusion Zones will only be visible on the list display of the calendar if they are 24x7 Schedules.</div>");
        lHtml.push("</br></br><div><input type='checkbox' name='eznoteinput' id='exclusionZoneNotification'> <label for='exclusionZoneNotification'> Never show this message again  </label> </input><div>")

        GenerateButton(localizeWrapper('cEnrolleeContinue'), '', function () {
            var check = $('#exclusionZoneNotification').is(":checked");

            if (check) localStorage.setItem("ezNotification", "notifiedAlready")
            ClosePopup();
        }).appendTo(lButtonBar);

        if (lZone.Type == 2) {
            DisplayPopup("Exclusion Zone Visibility", lHtml.join(''), lButtonBar, false, true);
        }
    }
    saveSchedulesMultiDay([lSchedule],
        function (aParams, aData) {
            FixDates(aData);
            if (!getCarveOutPreference())
                renderNewSchedule(aData);

            CarveOutOnSave_Success('Saved', aData);
            enrolleesCarveOutScheduleWrite_OnSuccess(aParams, aData);
        }, null);
}

function renderNewSchedule(aSchedules) {
    "use strict";
    var lCalendarId = mEnrolleesControls.carveOutSchedule.calendarId();
    var lView = $(lCalendarId).fullCalendar('getView');
    var lStartDate = moment(lView.start);
    var lEndDate = moment(lView.end);
    var lTimeZone = getEnrolleeTimeZone(mEnrolleesData.OffenderCurrentId);

    aSchedules.forEach(function (schedule) {
        var lSchedule = null;
        var lMoment = moment(lStartDate);

        schedule.StartTime = convertMomentFromStringTimezone(schedule.StartTimeUTC, lTimeZone.TimeZoneName);
        schedule.EndTime = convertMomentFromStringTimezone(schedule.EndTimeUTC, lTimeZone.TimeZoneName);

        var lScheduleStart = moment(schedule.StartDateUTC);
        var lScheduleEnd = moment(schedule.EndDateUTC);

        while (lMoment < lEndDate) {
            var lDay = lMoment.day();
            var lDate = DisplaySuperShortMomentDate(lMoment);
            var lSchedStart = moment(lDate + ' ' + displayShortTime(schedule.StartTime));
            var lSchedEnd = moment(lDate + ' ' + displayShortTime(schedule.EndTime));

            if (schedule.IsSunday && lDay == 0) {
                lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType);
                break;
            } else if (schedule.IsMonday && lDay == 1) {
                lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType);
                break;
            } else if (schedule.IsTuesday && lDay == 2) {
                lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType);
                break;
            } else if (schedule.IsWednesday && lDay == 3) {
                lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType);
                break;
            } else if (schedule.IsThursday && lDay == 4) {
                lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType);
                break;
            } else if (schedule.IsFriday && lDay == 5) {
                lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType);
                break;
            } else if (schedule.IsSaturday && lDay == 6) {
                lSchedule = new FullCalendarCarveOutSchedule(lSchedStart, lSchedEnd, schedule.ScheduleType, schedule.IsRecurring, schedule.EntityId, null, null, schedule.ZoneScheduleType);
                break;
            }
            lMoment.add(1, 'days');
        }
        if (lSchedule) {
            lSchedule.title = schedule.Name;
            lSchedule.data = schedule;

            $(lCalendarId).fullCalendar('renderEvent', lSchedule, true);
        }
    });

}

function popToScheduleTarget(aThis) {
    "use strict";
    var val = $('#uCarveOutScheduleSelectionSelect').val();
    var lData = mEnrolleesData.CarveOutScheduleTargetListView.getDataSource();

    if (lData['Z' + val]) { // remove
        delete lData['Z' + val];
        mEnrolleesData.CarveOutScheduleTargetListView.setDataSource(lData);
    } else {
        var lZone = getDataItem(val, 'Zones');
        var lScheduleTarget = generateZoneScheduleTarget(lZone);
        mEnrolleesData.CarveOutTargetsClean.push(lScheduleTarget);
        lData[lScheduleTarget.UniqueId] = lScheduleTarget;
        mEnrolleesData.CarveOutScheduleTargetListView.setDataSource(lData);
        mEnrolleesData.CarveOutScheduleTargetListView.selected(lScheduleTarget.UniqueId)
    }
}

function generateZoneScheduleTarget(zone) {
    "use strict";
    var lAddressName = zone.AddressTypeId > 0 ? " - " + addressTypeFormatter(zone.AddressTypeId) : "";
    var lScheduleTarget = new ScheduleTarget();
    lScheduleTarget.Id = zone.Id;
    lScheduleTarget.Name = zone.Name;
    lScheduleTarget.TypeId = 1;
    lScheduleTarget.AoiZoneEnable = zone.AoiZoneEnable;
    if (zone.Type === 1) {
        lScheduleTarget.TypeName = localizeText('cZoneInclusionZone') + lAddressName;
    } else {
        lScheduleTarget.TypeName = localizeText('cZoneExclusionZone') + lAddressName;
    }
    lScheduleTarget.UniqueId = 'Z' + zone.Id;

    return lScheduleTarget;
}

function generateDeviceScheduleTarget(id, type) {
    "use strict";
    var lName;
    var lScheduleTarget = new ScheduleTarget();

    if (id === -1) {
        lName = type == 'B' ? 'BLUhome' : 'BLUbox';
    }

    lScheduleTarget.Id = id;
    lScheduleTarget.Name =lName;
    lScheduleTarget.TypeId = type == 'B' ? 2 : 3;
    lScheduleTarget.TypeName = lName
    lScheduleTarget.UniqueId = type + id;

    return lScheduleTarget;
}

function populateAbsenceScheduleTargetList() {
    "use strict";

    if (!mEnrolleesData.CarveOutScheduleTargetListView) return;

    var lBuilder = new SumoPredicateBuilder();
    var lAssignments = gCurrentDeviceAssignment[mEnrolleesData.OffenderCurrentId] || [];
    var lScheduleTargets = [];
    var lZones = [];    
    var lScheduleTarget;
    var lZoneIdList = [];
    var lIsBLUhome = false;
    var lIsBLUbox = false;
    var lSort = new SortExpression();
    var lAddressName = "";

    var lSchedules = getEnrolleeSchedules()

    lSchedules.forEach(function (schedule) {
        if ([1, 8].indexOf(schedule.ScheduleType) !== -1)
            lZoneIdList.push(schedule.EntityId);
    });

    lBuilder.Clear();
    lBuilder.AddNewExpressionConditional('Id', lZoneIdList.unique(), false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
    lZones = query(getDataItems('Zones'), lBuilder.RootExpression);
    
    lSort.addAscendingColumn('Name');

    lZones = lSort.sort(lZones);

    lZones.forEach(function (zone) {
        lScheduleTarget = generateZoneScheduleTarget(zone);

        lScheduleTargets[lScheduleTarget.UniqueId] = lScheduleTarget;
        mEnrolleesData.CarveOutTargetsClean.push(lScheduleTarget);
    });

    lBuilder.Clear();

    lBuilder.AddNewExpressionConditional('IsActive', true, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
    mEnrolleesData.CarveOutScheduleTargetListView.setDataSource(lScheduleTargets);


    if(mEnrolleesData.SchedulesTargetsClean['B-1']){
        delete mEnrolleesData.SchedulesTargetsClean['B-1']
    }
    if (mEnrolleesData.SchedulesTargetsClean['D-1']) {
        delete mEnrolleesData.SchedulesTargetsClean['D-1']
    }

    var lBLUbox = filterScheduleTargets(3);
    var lBLUhome = filterScheduleTargets(2);

    lIsBLUbox = lBLUbox.length > 0;
    lIsBLUhome = lBLUhome.length > 0;

    $('#uCarveOutDeviceScheduleSelectionSelect').find('option').remove().end();
    $('#uCarveOutDeviceScheduleSelectionSelect').append($('<option></option>')
                            .attr('value', -1)
                            .text('Please select a device target....'))
    if (!lIsBLUhome && !lIsBLUbox) {
        // create both targets
        $('#uCarveOutDeviceScheduleSelectionSelect').append($('<option></option>')
                                            .attr('value', 'B-1')
                                            .text('BLUhome'));
        mEnrolleesData.SchedulesTargetsClean['B-1'] = generateDeviceScheduleTarget(-1, 'B');
        $('#uCarveOutDeviceScheduleSelectionSelect').append($('<option></option>')
                                            .attr('value', 'D-1')
                                            .text('BLUbox'));
        mEnrolleesData.SchedulesTargetsClean['D-1'] = generateDeviceScheduleTarget(-1, 'D');
    } else if (lIsBLUbox) {
        $('#uCarveOutDeviceScheduleSelectionSelect').append($('<option></option>')
                                            .attr('value', lBLUbox[0].UniqueId)
                                            .text('BLUbox ' + lBLUbox[0].Name))
    } else if (lIsBLUhome) {
        $('#uCarveOutDeviceScheduleSelectionSelect').append($('<option></option>')
                                            .attr('value', lBLUhome[0].UniqueId)
                                            .text('BLUhome ' + lBLUhome[0].Name))
    }

    var lAddresses = filterScheduleTargets(6);

    lAddresses.forEach(function (address) {
        mEnrolleesData.CarveOutTargetsClean.push(address);
        $('#uCarveOutDeviceScheduleSelectionSelect').append($('<option></option>')
                                .attr('value', address.UniqueId)
                                .text('BLU+ ' + address.TypeName + ' - ' + address.Name))

    });
}

function filterScheduleTargets(filterValue) {
    var lArray = [];
    var lKey;

    for (lKey in mEnrolleesData.SchedulesTargetsClean) {
        if (mEnrolleesData.SchedulesTargetsClean.hasOwnProperty(lKey)) {
            if (mEnrolleesData.SchedulesTargetsClean[lKey].TypeId == filterValue) {
                lArray.push(mEnrolleesData.SchedulesTargetsClean[lKey]);
            }
        }
    }

    return lArray;
}

function wipeAllOffenderSchedule(self) {
    "use strict";
    if ($(self).hasClass('Disabled')) {
        return false;
    }
    var lHtml = [];
    var lButtonBar = GenerateButtonCommandBar();

    lHtml.push('<div id="lockdownsection" style="height:200px"><p> Do you wish to delete all offender schedules?</p>');

    lHtml.push('<input type="checkbox" id="uExclusionZoneDeleteWipeAll" name="exclusionZoneDelete"/><label for="uExclusionZoneDeleteWipeAll" >Clear Exclusion Zone Schedule from Enrollee </label> ')
    lHtml.push('</div>');

    GenerateButton(localizeWrapper('cEnrolleeDelete'), 'Remove LockDownRemove', 'wipeAllSchedulesContinue()', false).appendTo(lButtonBar);

    DisplayPopup('Are you sure?', lHtml.join(''), lButtonBar, null, true);
}

function wipeAllSchedulesContinue() {
    "use strict";
    var lSchedules = [];
    var lExclusionZoneDelete = $('#uExclusionZoneDeleteWipeAll').is(":checked");
    var lScheduleList = getEnrolleeSchedules();

    if($('.LockDownRemoveButton').hasClass('Disabled'))return false

    $('.LockDownRemoveButton').addClass('Disabled');

    if (!lExclusionZoneDelete) {
        lScheduleList = lScheduleList.filter(function (schedule) {
                if (schedule.ZoneScheduleType == -1) return schedule;
                var lZone = GetZone(schedule.EntityId);
                if (!lZone) {
                    if (!schedule.ZoneName.includes("Exclusion")) {
                        return schedule;
                    }
                }
                if (lZone && lZone.Type !== 2) return schedule;
                // check if 24 hours
            })
    }
    lScheduleList.map(function (schedule) {
        schedule.IsActive = false;
        lSchedules.push(schedule);
    });

    $('#uCarveOutScheduleZoneTravel').prop('checked', false)

    mActivityNotification.addNotification('Deleting all schedules.....');
    WriteMultiple(lSchedules, function (aParams, aData) {
        ClosePopup();
        mActivityNotification.addNotification('Schedules Successfully Deleted');
        enrolleesCarveOutScheduleWrite_OnSuccess(aParams, aData)
    }, CarveOutOnSave_Fail, 'Deleted', true);
}